// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:27:33.356Z
// Property: The View at Lakeside (ID: 5657559276978176)
// Collections: 22 amenities, 6 floorplans (live), 26 photos, 84 POIs, 7 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5657559276978176",
  "property_external_id": "4432366",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/the-view-at-lakeside-lewisville-tx/j1w3047",
  "property_google_business_url": "https://www.google.com/maps/place/The+View+at+Lakeside/@33.0092417,-96.9631615,17z/data=!4m13!1m7!3m6!1s0x864c2f0329bb08e7:0xbd1b46fef639fc77!2s901+Lakeside+Cir,+Lewisville,+TX+75057!3b1!8m2!3d33.0092417!4d-96.9609675!3m4!1s0x864c2f032b16d041:0xb45d8597954ad669!8m2!3d33.0099498!4d-96.9612514",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443209787",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-view-at-lakeside",
  "property_name": "The View at Lakeside",
  "property_website_url": "https://www.theviewatlakeside.com/",
  "property_domain": "https://www.theviewatlakeside.com/",
  "property_address": "901 Lakeside Cir",
  "property_full_address": "901 Lakeside Cir, Lewisville, TX 75057",
  "property_address_1": "901 Lakeside Cir",
  "property_address_2": null,
  "property_address_city": "Lewisville",
  "property_address_state": "TX",
  "property_address_zip_full": "75057-5052",
  "property_address_zip": "75057",
  "property_address_country": "US",
  "property_address_county": "Denton County",
  "property_neighborhood_address": "Lewisville/Flower Mound",
  "property_address_latitude": "33.0093197",
  "property_address_longitude": "-96.9618469",
  "property_email": "lakeside@alapts.com",
  "property_phone": "(972) 315-6525",
  "property_call_tracking_phone": "469-405-3485",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Lake-view calm with Metroplex momentum.</strong> The View at Lakeside brings gated, pet-friendly apartment living to Lewisville’s Lakeside area, with polished one-, two-, and three-bedroom homes and easy access to major DFW connections. Schedule a tour and see the view for yourself.</p>",
  "property_long_description": "<p><strong>Lake-view calm with Metroplex momentum.</strong> At The View at Lakeside, you come home to a gated, pet-friendly apartment community in Lewisville’s Lakeside area, just across from Hebron Station and moments from I-35E and Sam Rayburn Tollway. Choose from one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with features like 9-foot ceilings, granite countertops, stainless steel appliances, designer cabinetry, built-in bookshelves, and private patios or balconies in select homes.</p><p>Outside your door, <a href=\"/amenities\">resort-style amenities</a> make everyday living feel easy: a pool and sundeck, cabana and grilling areas, fitness center, sand volleyball, clubhouse, conference rooms, package lockers, walking and biking trails, plus a Bark Park and pet spa. When you’re ready to explore, The Vista, Old Town Lewisville dining, LLELA’s nature trails, Lewisville Lake, and Flower Mound shopping are all within easy reach—giving you a relaxed lakeside address with quick connections across DFW.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-98a3-701c-be49-059d19abd67a.webp",
  "property_featured_image_media": {
    "alt_text": "Beautifully maintained swimming pool and hot tub area with lounge chairs and trees.",
    "public_id": "019e8a09-98a3-701c-be49-059d19abd67a",
    "storage_key": "property/5657559276978176/019e8a09-98a3-701c-be49-059d19abd67a.webp",
    "width": 2410,
    "height": 1604
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "360",
  "property_year_built": "1997",
  "property_year_renovated": "2018",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.38888888888889",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $25 / pet\nApplication Approval Fee Starting At $300\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://7634254.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://theviewatlakeside.loftliving.com/login",
  "property_apply_now_url": "https://7634254.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e7406-1362-72b8-9eb5-6d4b6f09f94a.webp",
  "property_primary_logo_media": {
    "alt_text": "The View at Lakeside Apartment Homes logo",
    "public_id": "019e7406-1362-72b8-9eb5-6d4b6f09f94a",
    "storage_key": "property/5657559276978176/019e7406-1362-72b8-9eb5-6d4b6f09f94a.webp",
    "width": 1186,
    "height": 349
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e7406-13ea-779d-bcb0-06f7d2a83171.webp",
  "property_secondary_logo_media": {
    "alt_text": "AT LAKESIDE logo",
    "public_id": "019e7406-13ea-779d-bcb0-06f7d2a83171",
    "storage_key": "property/5657559276978176/019e7406-13ea-779d-bcb0-06f7d2a83171.webp",
    "width": 1142,
    "height": 357
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e7406-1224-7034-a30e-588039749601.webp",
  "property_icon_media": {
    "alt_text": "V logo with green and blue elements.",
    "public_id": "019e7406-1224-7034-a30e-588039749601",
    "storage_key": "property/5657559276978176/019e7406-1224-7034-a30e-588039749601.webp",
    "width": 506,
    "height": 506
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e7406-1224-7034-a30e-588039749601.webp",
  "property_fav_icon_media": {
    "alt_text": "V logo with green and blue elements.",
    "public_id": "019e7406-1224-7034-a30e-588039749601",
    "storage_key": "property/5657559276978176/019e7406-1224-7034-a30e-588039749601.webp",
    "width": 506,
    "height": 506
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f675b-97cd-710a-a7a2-b0573b9b1eaf.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f675b-97cd-710a-a7a2-b0573b9b1eaf",
    "storage_key": "property/5657559276978176/019f675b-97cd-710a-a7a2-b0573b9b1eaf.webp",
    "width": 1186,
    "height": 349
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f675b-8bc4-745a-9537-0e4ee60ed4a2.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f675b-8bc4-745a-9537-0e4ee60ed4a2",
    "storage_key": "property/5657559276978176/019f675b-8bc4-745a-9537-0e4ee60ed4a2.webp",
    "width": 1186,
    "height": 349
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#7a9c3e",
  "property_secondary_color": "#848588",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#006496",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "675 - 1254",
  "property_sqft_min": "675",
  "property_sqft_max": "1254",
  "property_price_range": "1190 - 2195",
  "property_price_min": "1190",
  "property_price_max": "2195",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/TheViewAtLakeside",
  "property_instagram_url": "https://www.instagram.com/theviewatlakeside",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJQdAWKwMvTIYRadZKlZeFXbQ",
  "property_youtube_url": "https://www.youtube.com/watch?v=SkRnsFODaiA",
  "property_yelp_url": "https://www.yelp.com/biz/lakeside-121-lewisville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenities with lake-day energy.</strong> Recharge in the 24-hour fitness center, unwind at two resort-style pools, or take it outside with cabanas, grilling stations, a volleyball court, lake access, and walking/biking trails. Controlled-access gates, package service, door-to-door trash pickup, and on-site maintenance keep daily living streamlined, while granite countertops, stainless steel appliances, designer cabinetry, and pet-friendly perks like the Bark Park and pet spa add comfort where it counts.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit at The View at Lakeside.</strong> Choose from one-, two-, and three-bedroom apartments in Lewisville with open living and dining spaces, polished kitchens, granite countertops, designer cabinetry, stainless steel appliances, and pantry storage. Select layouts add 9-foot ceilings, wood-style flooring, built-in bookshelves, private patios or balconies, and extra storage—giving each floor plan a little more to love.</p>",
  "property_home_gallery_blurb": "<p><strong>See The View at Lakeside come into focus.</strong> Preview open living rooms filled with natural light, kitchens with granite countertops and stainless-steel appliances, and dining spaces designed with purpose. Then move outside to lake views, leafy courtyards, a resort-style pool, sundeck, cabanas, grilling areas, and lounge spaces that make the full gallery worth the scroll.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Lakeside calm, Lewisville connected.</strong> From The View at Lakeside, walk/bike paths, Hebron Station, I-35E, and Sam Rayburn Tollway keep the area easy to navigate. Old Town Lewisville adds local coffee, dining, live events, and open-air gathering spots, while LLELA brings trails, paddling, and wildlife habitat close to home. Explore the map, then see the neighborhood for yourself.</p>",
  "property_home_reviews_blurb": "<p><strong>Everyday details residents notice.</strong> Reviews for The View at Lakeside highlight a responsive office team, fast maintenance, clean grounds, and a convenient Lewisville location near shopping, dining, and major routes. Residents also call out lake views, well-kept outdoor spaces, a pond with a walking trail, and a clean dog park. Read the full reviews to see the service, setting, and community feel in residents’ own words.</p>",
  "property_neighborhood_blurb": "<p><strong>Explore Lewisville from a lakeside starting point.</strong> At The View at Lakeside, your neighborhood puts calm scenery and DFW access on the same map: walk/bike paths around the community, Hebron Station just across Lakeside Circle, and quick routes to I-35E and Sam Rayburn Tollway when the day takes you farther.</p><p>Head into Old Town Lewisville for craft coffee at The Perc, dinner and cocktails at Ethel Janes, concerts and gallery events at Lewisville Grand, or open-air moments at Wayne Ferguson Plaza. When you want more room to roam, LLELA’s trails, paddling spots, and wildlife habitat bring a true nature preserve close to home. See what’s nearby, then <a href=\"/schedule-a-tour\">schedule a tour</a> to connect the map to real life.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that work as hard as they relax.</strong> Start your day in the 24-hour fitness center, reset by one of two resort-style pools, or take the afternoon outside with cabanas, grilling areas, a volleyball court, lake access, and walking/biking trails woven through the community. Everyday details make life simpler, too, from controlled-access gates and Parcel Pending package service to online resident services, door-to-door trash pickup, and on-site maintenance.</p><p>Inside your apartment, polished finishes bring comfort into focus: granite countertops, stainless steel appliances, designer cabinetry, framed mirrors, ceiling fans, and select homes with 9-foot ceilings, built-in bookshelves, wood-style flooring, and patios or balconies. Pet-friendly perks, including the Bark Park and pet spa, add even more convenience at The View at Lakeside.</p>",
  "property_applynow_blurb": "<p><strong>Your lakeside Lewisville home starts here.</strong><br>Choose a one-, two-, or three-bedroom apartment with standout finishes like 9-foot ceilings, granite countertops, stainless steel appliances, and private outdoor space in select homes. With gated, pet-friendly living and quick DFW connections, The View at Lakeside makes it easy to apply online today.</p>",
  "property_contactus_blurb": "<p><strong>Questions? Need directions?</strong> Contact The View at Lakeside leasing team for help with availability, floor plans, or finding our gated, pet-friendly community in Lewisville’s Lakeside area—just across from Hebron Station and moments from I-35E and Sam Rayburn Tollway.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The View at Lakeside?</strong> Start here for quick answers about leasing, everyday living, <a href=\"/floor-plans\">floor plans</a>, pet-friendly details, and community features. If you don’t see what you need, the leasing team is happy to help—just <a href=\"/contact-us\">reach out</a>.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the space that matches your day.</strong> At The View at Lakeside, floor plans range from streamlined one-bedroom apartments to roomy two- and three-bedroom layouts, giving you options for easy routines, shared space, or extra room to spread out in Lewisville. Open living and dining areas keep the flow simple, while well-appointed kitchens with granite countertops, designer cabinetry, stainless steel appliances, and pantry storage bring a polished feel to the everyday.</p><p>Select homes add details like 9-foot ceilings, wood-style flooring, built-in bookshelves, private patios or balconies, and generous storage, so each layout has its own sense of finish. Browse current availability, compare pricing, and use the floor plan cards below to find the home you want to see in person—then <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready.</p>",
  "property_gallery_blurb": "<p><strong>Picture the day from every angle.</strong> Browse the photo gallery for The View at Lakeside and see the details that shape your apartment experience in Lewisville: sunlight across open living rooms, kitchens finished with granite countertops and stainless-steel appliances, and dining spaces that make each layout feel considered. Outside, the camera moves from lake views and leafy courtyards to the resort-style pool and sundeck. You’ll also spot cabanas, grilling areas, and relaxed lounge spaces that bring the community into focus. As you scroll, compare the look of one-, two-, and three-bedroom interiors, then explore <a href=\"/floor-plans\">available floor plans</a> or get a closer look with <a href=\"/virtual-tours\">virtual tours</a> before you visit in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore lake-view calm with DFW connections.</strong> Use the interactive map to browse available apartments at The View at Lakeside, then see what surrounds this Lewisville Lakeside address—from nearby transit and major roadways to dining, nature trails, lake recreation, and shopping within easy reach.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, zoomies, and post-walk cleanups.</strong> At The View at Lakeside, pet-friendly living is built into the routine—not added as an afterthought. Take your dog to the on-site <a href=\"/amenities\">Bark Park &amp; Posh Pet Spa</a>, follow the community’s walking and biking trails for an easy outdoor loop, or enjoy fresh air from a private patio or balcony in select homes.</p><p>Cats get comfortable here, too, with spacious apartment layouts and sunny spots to claim as their own. When you want a bigger outing in Lewisville, the city’s six-acre dog park at Railroad Park adds separate play areas, seating, fountains, waste stations, and a wash station nearby. Check the policy details below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how life with your pets fits at The View at Lakeside.</p>",
  "property_referafriend_blurb": "<p><strong>Share lake-view calm with Metroplex momentum.</strong> Love the gated, pet-friendly setting, stylish apartment finishes, and easy everyday amenities at The View at Lakeside? Invite a friend to see what makes this Lewisville community feel so effortless—then let the referral form help make the introduction.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made easy.</strong><br>From your gated, pet-friendly Lakeside community, manage the essentials in moments—pay rent, submit maintenance requests, and keep your account current so everyday living at The View at Lakeside stays as calm and connected as home should feel.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, real everyday wins.</strong> Residents at The View at Lakeside often point to the details that make daily life run smoother: a receptive office team, prompt maintenance, clean grounds, and a convenient Lewisville location close to shopping, restaurants, and major routes.</p><p>You’ll see praise for a “perfect view of the nearby lake,” well-kept outdoor spaces, a pond with a walking trail, and pet-friendly conveniences like a clean dog park. Longtime residents also call out staff who “go above and beyond” and maintenance that takes care of requests right away. Browse the reviews below to see how residents describe the service, setting, and community feel in their own words.</p>",
  "property_created_at": "1752256418813",
  "property_scheduletour_blurb": "<p><strong>See lakeside ease up close.</strong> Tour The View at Lakeside and experience gated, pet-friendly living with 9-foot ceilings, granite countertops, stainless steel appliances, and private patios or balconies in select homes. From the pool and sundeck to quick Metroplex connections, it’s all ready to explore—schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong> The leasing team at The View at Lakeside will follow up soon. In the meantime, picture a gated, pet-friendly Lewisville community with lake-view calm, stylish one-, two-, and three-bedroom homes, and easy everyday living near major DFW connections.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through before you walk in.</strong> The virtual tours at The View at Lakeside let you preview the spaces that shape daily life here—start with the community tour, then move through the clubhouse, fitness center, playground and volleyball area, and both swimming pool settings at your own pace.</p><p>Want a closer look inside a home? Step into the 2-bedroom, 2-bath B2 apartment tour to get a feel for the layout, finishes, kitchen flow, and room-to-room connection before comparing <a href=\"/floor-plans\">available floor plans</a>. When the views, amenities, and apartment details feel right on screen, <a href=\"/schedule-a-tour\">schedule a tour</a> to experience The View at Lakeside in Lewisville in person.</p>",
  "property_copyright": "2025 All Rights Reserved. The View at Lakeside",
  "property_seo_title_home": "The View at Lakeside | Apartments in Lewisville, TX",
  "property_seo_description_home": "Discover your dream home at The View at Lakeside in Lewisville, TX! Explore our spacious one, two, and three-bedroom floor plans designed for modern living. Enjoy premium amenities like a fitness center, resort-style pool, dog park, and clubhouse. With access gates, online resident services, and stunning lake views, your comfort and convenience are our top priorities. Don’t wait—find your new home today and experience lakeside living at its finest!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Lewisville, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at The View at Lakeside in Lewisville, TX. Explore our diverse floor plans, featuring one, two, and three-bedroom apartments designed for comfort and style. Browse our available apartment homes today and find the perfect fit for your lifestyle!",
  "property_seo_title_amenities": "Amenities | Lewisville, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover your ideal home at The View at Lakeside in Lewisville, TX! Choose from spacious one, two, and three-bedroom floor plans designed for comfort and style. Enjoy exceptional amenities, including a fitness center, pool, dog park, and clubhouse, along with modern features like gourmet kitchens and tall ceilings. With convenient online resident services and stunning views of the lake, your perfect lifestyle awaits. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Lewisville, TX",
  "property_seo_description_gallery": "Explore stunning apartment living at The View at Lakeside in Lewisville, TX! Browse our Photo Gallery to imagine your dream space with spacious one, two, and three-bedroom floor plans. Enjoy exceptional amenities like a modern fitness center, inviting pool, dog park, and vibrant clubhouse, along with breathtaking lake and courtyard views. Experience the perfect blend of luxury and comfort with designer finishes, gourmet kitchens, and modern conveniences. Picture yourself living here and discover your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | The View at Lakeside Apartments",
  "property_seo_description_virtualtours": "\"Explore The View at Lakeside in Lewisville, TX! Discover our beautifully designed one, two, and three-bedroom floor plans. Take a virtual tour of our vibrant community and find your perfect apartment for rent today! Your new home awaits!\"",
  "property_seo_title_interactivemap": "Interactive Map | The View at Lakeside Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at The View at Lakeside in Lewisville, TX! Explore our diverse floor plans featuring one, two, and three-bedroom apartments. Enjoy top-notch amenities, including a sparkling pool, fitness center, dog park, and more. Unwind on your private patio or utilize our online resident services. Use our interactive community map to search available apartments, view pricing, and select your new home today! Experience lakeside living at its finest!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Lewisville, TX",
  "property_seo_description_neighborhood": "Discover the vibrant surroundings of The View at Lakeside in Lewisville, TX! Explore our diverse floor plans, including one, two, and three-bedroom apartments, while uncovering local favorites and nearby points of interest. See what's around our community today!",
  "property_seo_title_contact": "Contact Us | The View at Lakeside",
  "property_seo_description_contact": "Discover your dream home at The View at Lakeside in Lewisville, TX! Explore our spacious one, two, and three-bedroom floor plans designed for comfort and style. Have questions? Contact our leasing team today and let us help you find the perfect apartment for your lifestyle!",
  "property_seo_title_faqs": "FAQs | Apartments in Lewisville, TX",
  "property_seo_description_faqs": "Discover your ideal home at The View at Lakeside in Lewisville, TX! Explore our diverse floor plans, featuring one, two, and three-bedroom apartments designed with luxury in mind. Enjoy top-notch amenities including a state-of-the-art fitness center, a relaxing pool, and a dog park. Have questions? Browse our FAQs page for answers about our community and make your dream apartment a reality today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Lewisville, TX",
  "property_seo_description_reviews": "\"Discover the charm of The View at Lakeside in Lewisville, TX! Explore our spacious one, two, and three-bedroom floor plans, enhanced by premium amenities like a dog park, fitness center, and serene lake views. Enjoy online resident services, a contemporary clubhouse, and beautiful outdoor spaces, including a grill area and playground. Don’t just take our word for it—see what our residents have to say about their life at our vibrant community! Join us today!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Lewisville, TX",
  "property_seo_description_applynow": "Discover your perfect sanctuary at The View at Lakeside in Lewisville, TX! With spacious one, two, and three-bedroom floor plans, our community boasts exceptional amenities including a state-of-the-art fitness center, dog park, clubhouse, and inviting pool area. Retreat to our stylish homes featuring gourmet kitchens, tall ceilings, and beautiful views - whether it's a tranquil lake view or a vibrant courtyard vista. Enjoy convenient online resident services and a welcoming atmosphere. Don't wait – find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The View at Lakeside",
  "property_seo_description_residentaccess": "\"Welcome to The View at Lakeside in Lewisville, TX! Access your resident portal to effortlessly pay rent, schedule maintenance, and manage your community services. Experience convenient living at your fingertips!\"",
  "property_seo_title_referafriend": "Refer A Friend | The View at Lakeside",
  "property_seo_description_referafriend": "\"Discover the perfect home for you and your friends at The View at Lakeside in Lewisville, TX! Refer a friend and enjoy a vibrant community where great friends become great neighbors. Join us today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The View at Lakeside",
  "property_seo_description_scheduletour": "Discover your dream home at The View at Lakeside in Lewisville, TX! Schedule a tour today and explore our stunning apartment community, complete with breathtaking views and modern amenities. Don't miss the chance to find your perfect living space!",
  "property_seo_title_privacy": "Privacy Policy | The View at Lakeside",
  "property_seo_description_privacy": "Discover how we protect your information at The View at Lakeside in Lewisville, TX. Our privacy policy ensures transparency and security for all our residents. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The View at Lakeside",
  "property_seo_description_accessibility": "Discover The View at Lakeside in Lewisville, TX, where we prioritize digital inclusion for all residents. Explore our Accessibility Statement to learn how we ensure everyone can enjoy our community's features and amenities. Join us in creating a welcoming environment—discover your new home today!",
  "property_seo_title_sitemap": "Sitemap | The View at Lakeside",
  "property_seo_description_sitemap": "Explore The View at Lakeside in Lewisville, TX! Navigate our sitemap to discover community features, amenities, and floor plans that make your living experience exceptional. Click now to plan your perfect apartment journey!",
  "property_seo_title_thankyou": "Thank You | The View at Lakeside",
  "property_seo_description_thankyou": "Thank you for reaching out to The View at Lakeside in Lewisville, TX! We're excited to assist you in finding your perfect apartment. A member of our team will contact you shortly to answer your questions and guide you through the next steps. Discover lakeside living at its finest!",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320922",
  "amenities": [
    {
      "id": "custom_6c537ab7-6477-47f9-abd5-c517769bf182",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b786c494-7516-4762-993f-d595ea5c5297",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d3e65cb6-4219-4d3b-87bd-bba8d47aa6ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000603",
      "title": "Blinds",
      "amount": "0.0000",
      "description": "2\" Faux Wood Blinds",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9410c24d-7f5e-4e52-bddb-e51171c171fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Designer Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d33ea65-48c5-45ff-b508-0b42a69a60e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c188690-7a50-4858-879c-eb6619172de4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000676",
      "title": "Sink",
      "amount": "0.0000",
      "description": "Stainless Steel Undermount Sink",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6bb3c98b-b1ac-4e92-ab56-74bc6742efae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9` Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5ab8b640-c9d9-477b-bd12-48d269a37b4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d018729-a4f5-4379-9def-e5183ac7c3e2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "2 Resort-Inspired Pools",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_875804d0-dc4a-4e59-9620-9be724a65869",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park & Posh Pet Spa",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4fcf412a-6435-4683-ab6f-1744eac6d9c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2acbb2b3-f0a6-45e2-9c21-e25213a5c0b2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Community Grilling & Picnic Areas",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_758e5c76-170c-4ece-b1ce-8cef1c56b5d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000665",
      "title": "Package System",
      "amount": "0.0000",
      "description": "Parcel Pending Package System",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_12e471b2-94e7-4fca-abbf-9086ade3dcac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000667",
      "title": "Parking",
      "amount": "0.0000",
      "description": "Reserved Parking Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d70ef85e-6b1a-4ce6-8611-dade3b534dfb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000668",
      "title": "Playground",
      "amount": "0.0000",
      "description": "Playground",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ac5eff51-c813-4099-abe5-8acceb73a320",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000614",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Resident Clubhouse",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3bf33b26-8728-442c-bad2-6ed616f1ef4b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000687",
      "title": "Storage Spaces",
      "amount": "0.0000",
      "description": "Complimentary Storage Access",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7df1cb36-c326-4898-b826-2333fa66ec68",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000701",
      "title": "Volleyball Court",
      "amount": "0.0000",
      "description": "Volleyball Court",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_122a40cd-3ace-4985-aa2b-879a6987b10e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000594",
      "title": "Access Gates",
      "amount": "0.0000",
      "description": "Controlled Access Gates",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_72957b5d-d160-4634-a214-c8189d0c0b40",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000002365",
      "title": "Conference Room",
      "amount": "0.0000",
      "description": "Conference Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ef233df9-c6b8-4385-8b72-262f1041c65c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d86eadca-8ef7-4226-9d7a-d16002637f17",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a4bd06f4-b636-4f0d-8a3f-312017510e63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-cf09-72c6-a33b-3364f6be2bc1.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at a multifamily property.",
        "public_id": "019e8a09-cf09-72c6-a33b-3364f6be2bc1",
        "storage_key": "property/5657559276978176/019e8a09-cf09-72c6-a33b-3364f6be2bc1.webp",
        "width": 2412,
        "height": 1605
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the resort-style swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Perfect for soaking up the sun or unwinding after a long day.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e875d16f-510c-438a-9499-441663c7540d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-cbee-7271-8437-ca85f0567cbc.webp",
      "image_media": {
        "alt_text": "Lobby area with plush seating and large windows overlooking the pool.",
        "public_id": "019e8a09-cbee-7271-8437-ca85f0567cbc",
        "storage_key": "property/5657559276978176/019e8a09-cbee-7271-8437-ca85f0567cbc.webp",
        "width": 2934,
        "height": 2115
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed lobby, featuring comfortable seating and expansive windows with views of the resort-style pool.",
      "link": "",
      "alt_text": "Lobby area with plush seating and large windows overlooking the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_964504a5-dc73-4fb3-8199-6d53dffe2d34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-cd4c-738b-8e5a-4dc64279ffd9.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with sand volleyball court, playground, and gazebo.",
        "public_id": "019e8a09-cd4c-738b-8e5a-4dc64279ffd9",
        "storage_key": "property/5657559276978176/019e8a09-cd4c-738b-8e5a-4dc64279ffd9.webp",
        "width": 2717,
        "height": 1527
      },
      "title": "Community",
      "description": "Discover our community amenities, including a sand volleyball court, children's playground, and a charming gazebo perfect for outdoor gatherings.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with sand volleyball court, playground, and gazebo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9e5b83d9-284b-489d-b8e0-7eb86903c059",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-cccd-750b-91d2-cb45f05560db.webp",
      "image_media": {
        "alt_text": "Modern community lounge with a large kitchen island, bar stools, and comfortable seating areas.",
        "public_id": "019e8a09-cccd-750b-91d2-cb45f05560db",
        "storage_key": "property/5657559276978176/019e8a09-cccd-750b-91d2-cb45f05560db.webp",
        "width": 3014,
        "height": 2006
      },
      "title": "Community",
      "description": "Gather in our spacious community lounge, featuring a full kitchen island, bar seating, and a beautifully appointed living area perfect for socializing.",
      "link": "",
      "alt_text": "Modern community lounge with a large kitchen island, bar stools, and comfortable seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_82a657f4-50b9-4b6a-9466-b442b4f71371",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-b9a6-71e2-a0ca-2eedef334830.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a granite countertop vanity, toilet, and bathtub with a patterned shower curtain.",
        "public_id": "019e8a09-b9a6-71e2-a0ca-2eedef334830",
        "storage_key": "property/5657559276978176/019e8a09-b9a6-71e2-a0ca-2eedef334830.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious vanity with a granite countertop, a modern sink, and a bathtub with a stylish patterned shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a granite countertop vanity, toilet, and bathtub with a patterned shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_95235bf3-9dca-4f23-907b-321fdffda638",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-bb95-72ac-bc0b-fde2cdeee3f3.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, and granite countertops.",
        "public_id": "019e8a09-bb95-72ac-bc0b-fde2cdeee3f3",
        "storage_key": "property/5657559276978176/019e8a09-bb95-72ac-bc0b-fde2cdeee3f3.webp",
        "width": 2571,
        "height": 1722
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this beautifully appointed kitchen featuring stainless steel appliances, ample cabinet space, and elegant granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9db6a66d-f562-4798-94f6-4cc7479101b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-b4e3-75fc-bbcc-0819f9c15bcd.webp",
      "image_media": {
        "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and a hot tub surrounded by trees and apartment buildings.",
        "public_id": "019e8a09-b4e3-75fc-bbcc-0819f9c15bcd",
        "storage_key": "property/5657559276978176/019e8a09-b4e3-75fc-bbcc-0819f9c15bcd.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style outdoor swimming pool, complete with a relaxing hot tub and ample lounge seating. Perfect for unwinding or soaking up the sun.",
      "link": "",
      "alt_text": "Aerial view of a kidney-shaped swimming pool with lounge chairs and a hot tub surrounded by trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b4f8078-5799-4200-80da-a8067ae6bc52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-b9e6-720b-825e-ac3c18a0b1d9.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool and hot tub with lounge chairs and umbrellas on a sunny day.",
        "public_id": "019e8a09-b9e6-720b-825e-ac3c18a0b1d9",
        "storage_key": "property/5657559276978176/019e8a09-b9e6-720b-825e-ac3c18a0b1d9.webp",
        "width": 2502,
        "height": 1539
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax in the hot tub by the resort-style pool, surrounded by lush landscaping and comfortable seating.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool and hot tub with lounge chairs and umbrellas on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fcd55951-3d65-44c6-807d-f273c41aa411",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-b6d0-73f8-a0c0-f9f42212c41a.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, treadmills, and exercise equipment.",
        "public_id": "019e8a09-b6d0-73f8-a0c0-f9f42212c41a",
        "storage_key": "property/5657559276978176/019e8a09-b6d0-73f8-a0c0-f9f42212c41a.webp",
        "width": 2572,
        "height": 1760
      },
      "title": "Community",
      "description": "Our fully equipped fitness center features state-of-the-art weight machines, treadmills, and everything you need for a great workout.",
      "link": "",
      "alt_text": "Gym with weight machines, treadmills, and exercise equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3549aa1c-6d3c-4245-b09f-f96377e8921a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-b77d-7681-a721-8064d06709c8.webp",
      "image_media": {
        "alt_text": "Apartment buildings on the edge of a lake.",
        "public_id": "019e8a09-b77d-7681-a721-8064d06709c8",
        "storage_key": "property/5657559276978176/019e8a09-b77d-7681-a721-8064d06709c8.webp",
        "width": 3072,
        "height": 1727
      },
      "title": "Community",
      "description": "Experience waterfront living with these beautiful apartment buildings situated on the edge of a serene lake.",
      "link": "",
      "alt_text": "Apartment buildings on the edge of a lake.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3b9ac785-d9fb-4403-8e56-7613e7329020",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-b2ff-74f2-9554-fc267ccfdc10.webp",
      "image_media": {
        "alt_text": "Covered patio with comfortable seating and outdoor tables.",
        "public_id": "019e8a09-b2ff-74f2-9554-fc267ccfdc10",
        "storage_key": "property/5657559276978176/019e8a09-b2ff-74f2-9554-fc267ccfdc10.webp",
        "width": 3017,
        "height": 2007
      },
      "title": "Community",
      "description": "Relax and unwind on our comfortable outdoor patio, featuring ample seating and stylish tables, perfect for enjoying the fresh air.",
      "link": "",
      "alt_text": "Covered patio with comfortable seating and outdoor tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_41c5f6b1-4c16-4388-a7a7-bf7de8aead82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-b6d4-7338-842a-e2005a7392d0.webp",
      "image_media": {
        "alt_text": "Living room with television, sofa, coffee table, and a view of the kitchen.",
        "public_id": "019e8a09-b6d4-7338-842a-e2005a7392d0",
        "storage_key": "property/5657559276978176/019e8a09-b6d4-7338-842a-e2005a7392d0.webp",
        "width": 2420,
        "height": 1610
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a built-in entertainment center with a television, a comfortable blue sofa, and a stylish coffee table. The open layout provides a view into the modern kitchen.",
      "link": "",
      "alt_text": "Living room with television, sofa, coffee table, and a view of the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e794f161-188b-409f-8e35-5011f260fd04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-b3b2-74d0-a9b3-37f90d8dacbd.webp",
      "image_media": {
        "alt_text": "Dining area with a glass-top table set for four, adjacent to a kitchen with stainless steel appliances and a breakfast bar.",
        "public_id": "019e8a09-b3b2-74d0-a9b3-37f90d8dacbd",
        "storage_key": "property/5657559276978176/019e8a09-b3b2-74d0-a9b3-37f90d8dacbd.webp",
        "width": 3015,
        "height": 2006
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining in this beautifully appointed apartment, featuring a spacious dining area perfect for entertaining and a modern kitchen.",
      "link": "",
      "alt_text": "Dining area with a glass-top table set for four, adjacent to a kitchen with stainless steel appliances and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8044950b-fc56-4792-aa02-9018b97a8a82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-b1b9-717b-8ef8-da8d4070789c.webp",
      "image_media": {
        "alt_text": "Outdoor grilling and dining area with a pergola and tables under a clear blue sky.",
        "public_id": "019e8a09-b1b9-717b-8ef8-da8d4070789c",
        "storage_key": "property/5657559276978176/019e8a09-b1b9-717b-8ef8-da8d4070789c.webp",
        "width": 2327,
        "height": 1548
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings and cookouts in our community grilling area, featuring a built-in grill and comfortable seating under a shaded pergola.",
      "link": "",
      "alt_text": "Outdoor grilling and dining area with a pergola and tables under a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1c3143bb-d10f-4764-a5b6-ae9648be9ee8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-a789-753f-b602-d425cafdda1e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with a pathway and green lawn.",
        "public_id": "019e8a09-a789-753f-b602-d425cafdda1e",
        "storage_key": "property/5657559276978176/019e8a09-a789-753f-b602-d425cafdda1e.webp",
        "width": 2303,
        "height": 1532
      },
      "title": "Community",
      "description": "Beautifully maintained grounds with a winding pathway, lush green lawns, and manicured hedges leading to the apartment buildings.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with a pathway and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1493140f-b1a6-4fad-8552-fad0999eab94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-a7e8-7129-9e54-6750132ce25b.webp",
      "image_media": {
        "alt_text": "Bedroom with queen bed, nightstand, and window.",
        "public_id": "019e8a09-a7e8-7129-9e54-6750132ce25b",
        "storage_key": "property/5657559276978176/019e8a09-a7e8-7129-9e54-6750132ce25b.webp",
        "width": 2195,
        "height": 1492
      },
      "title": "Apartment",
      "description": "A cozy bedroom featuring a comfortable queen-size bed with teal bedding and plush pillows, a modern nightstand with a lamp, and a large window offering natural light.",
      "link": "",
      "alt_text": "Bedroom with queen bed, nightstand, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59e05a18-0e29-4ebe-b36a-35b1260c2c44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-98fc-7672-8393-d03644ccdc25.webp",
      "image_media": {
        "alt_text": "Treadmills and weight machines in a well-lit fitness center.",
        "public_id": "019e8a09-98fc-7672-8393-d03644ccdc25",
        "storage_key": "property/5657559276978176/019e8a09-98fc-7672-8393-d03644ccdc25.webp",
        "width": 2414,
        "height": 1606
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio and weight training equipment available for resident use.",
      "link": "",
      "alt_text": "Treadmills and weight machines in a well-lit fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb90d941-532e-4e12-a01b-ce7686823dee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-9396-729b-acb0-2981015376c5.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sofa, teal and gray pillows, and two lamps.",
        "public_id": "019e8a09-9396-729b-acb0-2981015376c5",
        "storage_key": "property/5657559276978176/019e8a09-9396-729b-acb0-2981015376c5.webp",
        "width": 2408,
        "height": 1602
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living room, featuring a comfortable gray sofa, chic decorative pillows, and ambient lighting.",
      "link": "",
      "alt_text": "Modern living room with a gray sofa, teal and gray pillows, and two lamps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_285e3eb6-4bd8-4dab-aafa-cf08e1177457",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-98a3-701c-be49-059d19abd67a.webp",
      "image_media": {
        "alt_text": "Beautifully maintained swimming pool and hot tub area with lounge chairs and trees.",
        "public_id": "019e8a09-98a3-701c-be49-059d19abd67a",
        "storage_key": "property/5657559276978176/019e8a09-98a3-701c-be49-059d19abd67a.webp",
        "width": 2410,
        "height": 1604
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool or relax in the soothing hot tub. Surrounded by lush trees and comfortable lounge chairs, it's the perfect oasis for unwinding.",
      "link": "",
      "alt_text": "Beautifully maintained swimming pool and hot tub area with lounge chairs and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bb15a263-664d-40c3-9314-de5a68ddc50f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-98af-745a-ba7a-a0e128f21d75.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in an apartment with a dining table set for four.",
        "public_id": "019e8a09-98af-745a-ba7a-a0e128f21d75",
        "storage_key": "property/5657559276978176/019e8a09-98af-745a-ba7a-a0e128f21d75.webp",
        "width": 2420,
        "height": 1610
      },
      "title": "Apartment",
      "description": "Enjoy meals with friends and family in this beautifully appointed dining area, seamlessly connected to a modern kitchen. Perfect for entertaining.",
      "link": "",
      "alt_text": "Dining area and kitchen in an apartment with a dining table set for four.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f50cdf3f-a3f3-4706-bd36-e4a015fa1568",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-92d3-773e-8064-1265fcea999a.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, teal accent wall, and modern decor.",
        "public_id": "019e8a09-92d3-773e-8064-1265fcea999a",
        "storage_key": "property/5657559276978176/019e8a09-92d3-773e-8064-1265fcea999a.webp",
        "width": 2420,
        "height": 1610
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable king-size bed, a teal accent wall with abstract art, and elegant bedside tables. Perfect for relaxation and rest.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, teal accent wall, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_909b72a1-2c0e-457d-b694-43762ce0f612",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-9396-729b-acb0-2518bb11b65b.webp",
      "image_media": {
        "alt_text": "The View at Lakeside apartment complex entrance sign with manicured landscaping and apartment buildings in the background.",
        "public_id": "019e8a09-9396-729b-acb0-2518bb11b65b",
        "storage_key": "property/5657559276978176/019e8a09-9396-729b-acb0-2518bb11b65b.webp",
        "width": 2400,
        "height": 1597
      },
      "title": "Community",
      "description": "Welcome to The View at Lakeside, where luxury living meets convenience. Our premier apartments offer a sophisticated lifestyle surrounded by beautiful landscaping and top-notch amenities.",
      "link": "",
      "alt_text": "The View at Lakeside apartment complex entrance sign with manicured landscaping and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4bd1cf57-e520-4731-b648-fe2c7d868500",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-9280-724c-8562-5c9668288eb5.webp",
      "image_media": {
        "alt_text": "Conference room with two large tables and office chairs",
        "public_id": "019e8a09-9280-724c-8562-5c9668288eb5",
        "storage_key": "property/5657559276978176/019e8a09-9280-724c-8562-5c9668288eb5.webp",
        "width": 2198,
        "height": 1414
      },
      "title": "Community",
      "description": "Host your next meeting or event in our spacious conference room, perfect for business or social gatherings.",
      "link": "",
      "alt_text": "Conference room with two large tables and office chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9edaab3b-e337-4a63-bb53-55cc6a920743",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-9395-74ad-a76c-556258b6d5b4.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a pool and a lake.",
        "public_id": "019e8a09-9395-74ad-a76c-556258b6d5b4",
        "storage_key": "property/5657559276978176/019e8a09-9395-74ad-a76c-556258b6d5b4.webp",
        "width": 2177,
        "height": 1223
      },
      "title": "Community",
      "description": "Discover comfortable living in these scenic apartment buildings, featuring a refreshing pool and a tranquil lakefront setting. Enjoy the community amenities.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with a pool and a lake.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_43d6f20c-4090-420b-914b-00a9d5329e07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-9334-77c3-928e-285eb36718b1.webp",
      "image_media": {
        "alt_text": "Open-concept living and dining area with kitchen bar seating.",
        "public_id": "019e8a09-9334-77c3-928e-285eb36718b1",
        "storage_key": "property/5657559276978176/019e8a09-9334-77c3-928e-285eb36718b1.webp",
        "width": 2802,
        "height": 1871
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a TV console, coffee table, and access to a dining area and modern kitchen with bar stools.",
      "link": "",
      "alt_text": "Open-concept living and dining area with kitchen bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a315ff1b-9d2b-4241-a2c4-a683072fad78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019e8a09-9376-7376-848f-649b563bd8c9.webp",
      "image_media": {
        "alt_text": "A beautifully maintained outdoor swimming pool with lounge chairs and umbrellas, surrounded by lush green trees and apartment buildings.",
        "public_id": "019e8a09-9376-7376-848f-649b563bd8c9",
        "storage_key": "property/5657559276978176/019e8a09-9376-7376-848f-649b563bd8c9.webp",
        "width": 2413,
        "height": 1606
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, featuring comfortable lounge seating and vibrant umbrellas. Perfect for a sunny afternoon escape.",
      "link": "",
      "alt_text": "A beautifully maintained outdoor swimming pool with lounge chairs and umbrellas, surrounded by lush green trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_4304ed1ab4083847c22eb361",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "The Perc Coffeehouse",
      "poi_type": "Restaurants",
      "poi_address": "115 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "Vintage-style coffee bar featuring a variety of brews and seating options for relaxing or working.",
      "poi_long_description": "false",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJy1vijBEuTIYRzo1sqv5SDno/photos/AaVGc3loRr6ssAd46bPBx33c4xC64pIUOGsI4TrwkGDwSH0pmpsDaFSLpPt3A4ZgKvo3jT-MecBvhyvBClYZlHZ8gYE1hU_Jir6mqd2A17ed8-5hQczpUA0wEoszwpu6iF50MewvM4WKkKxKnjxa0KDUQXRm_p2MUrJdSS4hgD1YlA8yckAogx-i2rr6IwSk9RgnhVTQNHkpN0iPL2pw9nfGHZYw9RqXNmp5JNyPkJMDnLo6ujQW_PEl_fMfe0hOPBrzU1NKe0poqRHrlnlTRlS_guiukjseVByBJgnPfBWSs-ZayYT1-_8weIJxJiwSHmf-Shd7f3Qg_iWEdCIWnzVv2Bh-64ai4LnvT3stRw1T1_ypAzHfC839KAKC9carQOMVn9BdbsbLp-kvWSvLSIx3Y1buxRPeFE3hiKZC7D-djhxoHRK3/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4800&maxHeightPx=3200",
      "poi_featured_image_media": null,
      "poi_business_url": "https://perccoffeehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8795058376035569102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-perc-coffeehouse",
      "poi_latitude": "33.046461",
      "poi_longitude": "-96.994644",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-222-1404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ed-4a29-75da-a4c1-7023298df404.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4a29-75da-a4c1-7023298df404",
        "storage_key": "property/5657559276978176/019f14ed-4a29-75da-a4c1-7023298df404.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJy1vijBEuTIYRzo1sqv5SDno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_a5b0fcc3a58aef91129ba098",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Seven Mile Cafe",
      "poi_type": "Restaurants",
      "poi_address": "201 W Church St, Lewisville, TX 75057, USA",
      "poi_short_description": "Modern restaurant for pancakes and waffles, plus burgers, salads and chicken sandwiches, in cozy digs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-a94f-77ac-885f-be255d32dace.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-a94f-77ac-885f-be255d32dace",
        "storage_key": "property/5657559276978176/019f14ec-a94f-77ac-885f-be255d32dace.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sevenmilecafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7030752155365641576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seven-mile-cafe",
      "poi_latitude": "33.0474998",
      "poi_longitude": "-96.9968873",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-444-7055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEUC7YK0vTIYRaI1htNU_kmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_148342c38b0dfee906ea83a0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Starship Bagel",
      "poi_type": "Restaurants",
      "poi_address": "1108 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-a169-71da-812c-d525cb46a032.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-a169-71da-812c-d525cb46a032",
        "storage_key": "property/5657559276978176/019f14ec-a169-71da-812c-d525cb46a032.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.starshipbagel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6523622273519629777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starship-bagel",
      "poi_latitude": "33.0408676",
      "poi_longitude": "-97.021586",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-946-9033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ43hWmYgtTIYR0bX25eSPiFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "ec_31c5d5c81b4c1b8cb3512890",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "D'Nonna",
      "poi_type": "Restaurants",
      "poi_address": "233 W Church St, Lewisville, TX 75057, USA",
      "poi_short_description": "Casual eatery for pizza chicken dishes and pasta dishes, served amid cozy Italian decor.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-a1cd-76f8-aefe-766064efdb5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-a1cd-76f8-aefe-766064efdb5a",
        "storage_key": "property/5657559276978176/019f14ec-a1cd-76f8-aefe-766064efdb5a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://dnonnastx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6484643457619944022&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dnonna",
      "poi_latitude": "33.0474803",
      "poi_longitude": "-96.9971419",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-240-0008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0eYviusvTIYRVmJ_Gt4U_lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_5d9cf43c8def40e684cd0ead",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Prairie House Restaurant-Lewisville",
      "poi_type": "Restaurants",
      "poi_address": "119 E Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "Updated steakhouse dining & full bar in a rustic-chic space inside a former feed mill from 1886.",
      "poi_long_description": "Updated steakhouse dining & full bar in a rustic-chic space inside a former feed mill from 1886.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-a9bc-773c-810e-d9cc2cb63022.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-a9bc-773c-810e-d9cc2cb63022",
        "storage_key": "property/5657559276978176/019f14ec-a9bc-773c-810e-d9cc2cb63022.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://phtexaslewisville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6307053305945780996&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-house-restaurant-lewisville",
      "poi_latitude": "33.0466054",
      "poi_longitude": "-96.9932381",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-537-5547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr0CAhBEuTIYRBPNZyJAnh1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_c6ca314784f218f3667af0ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Ethel Janes - BENDT Whiskey Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "306 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-a438-725c-908b-50e5dde7e2d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-a438-725c-908b-50e5dde7e2d7",
        "storage_key": "property/5657559276978176/019f14ec-a438-725c-908b-50e5dde7e2d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.etheljanes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17054353003712899985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ethel-janes---bendt-whiskey-kitchen",
      "poi_latitude": "33.0460992",
      "poi_longitude": "-96.9980623",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-814-0545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSr8SQAvTIYRkWts9LI7rew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_72da6a6bc8c86331e0249142",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Old Hag's Pizza and Pasta",
      "poi_type": "Restaurants",
      "poi_address": "359 Lake Park Rd Ste 132, Lewisville, TX 75057, USA",
      "poi_short_description": "Casual pizzeria serving New York-style pies as well as pasta and wings.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-a4f9-7469-a6fb-0320e1fc14d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-a4f9-7469-a6fb-0320e1fc14d2",
        "storage_key": "property/5657559276978176/019f14ec-a4f9-7469-a6fb-0320e1fc14d2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://oldhagspizza.com/lewisville-menu",
      "poi_directions_map_url": "https://maps.google.com/?cid=3035238715160853161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-hags-pizza-and-pasta",
      "poi_latitude": "33.0717117",
      "poi_longitude": "-97.0153811",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-999-6899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWX52UCszTIYRqfqssYdVHyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_a0f3deaef23f648c65fc8085",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "BJ's Restaurant & Brewhouse",
      "poi_type": "Restaurants",
      "poi_address": "2609 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_long_description": "Family-friendly chain outpost pairs familiar pub fare with an extensive list of house brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-a134-750e-891e-a0ff416cc60c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-a134-750e-891e-a0ff416cc60c",
        "storage_key": "property/5657559276978176/019f14ec-a134-750e-891e-a0ff416cc60c.webp",
        "width": 1280,
        "height": 620
      },
      "poi_business_url": "https://www.bjsrestaurants.com/locations/tx/lewisville?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=10495617677568120392&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bjs-restaurant--brewhouse",
      "poi_latitude": "33.0001063",
      "poi_longitude": "-96.9620762",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-459-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKVhtTh4vTIYRSBbCaavsp5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_e72286f0882016af44245c28",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Saltgrass Steak House",
      "poi_type": "Restaurants",
      "poi_address": "801 State Hwy 121, Lewisville, TX 75067, USA",
      "poi_short_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_long_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-a24d-77fc-930c-f9fbb38ae704.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-a24d-77fc-930c-f9fbb38ae704",
        "storage_key": "property/5657559276978176/019f14ec-a24d-77fc-930c-f9fbb38ae704.webp",
        "width": 1280,
        "height": 1004
      },
      "poi_business_url": "https://www.saltgrass.com/location/saltgrass-lewisville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4789109307063384731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saltgrass-steak-house",
      "poi_latitude": "32.9954818",
      "poi_longitude": "-96.966362",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-316-0086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ9PdAeIuTIYRm7oHfopVdkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_856f4635ff2964d59d4d604d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Charlie's Lakeside Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "1481 E Hill Park Rd, Lewisville, TX 75056, USA",
      "poi_short_description": "Chill restaurant offering comfort bites, a patio, live music on weekends, and views of Lewisville Lake.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-a487-7668-9251-90ac5b153c3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-a487-7668-9251-90ac5b153c3a",
        "storage_key": "property/5657559276978176/019f14ec-a487-7668-9251-90ac5b153c3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seeyouatcharlies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15577560970222828930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlies-lakeside-bar-and-grill",
      "poi_latitude": "33.0777112",
      "poi_longitude": "-96.9194803",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 972-292-9885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr9ED2nM7TIYRgv0eQSudLtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_dffedc57aa921c719e30cd7e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Shady's Burgers & Brewhaha",
      "poi_type": "Restaurants",
      "poi_address": "20400 Hackberry Creek Park Rd suite 100, Frisco, TX 75036, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-aa80-7726-9b24-8d103854fbb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-aa80-7726-9b24-8d103854fbb1",
        "storage_key": "property/5657559276978176/019f14ec-aa80-7726-9b24-8d103854fbb1.webp",
        "width": 1280,
        "height": 965
      },
      "poi_business_url": "https://shadysburgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10859101319355801346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shadys-burgers--brewhaha",
      "poi_latitude": "33.1276453",
      "poi_longitude": "-96.9320783",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 34 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 972-292-9677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIURgiOkxTIYRAp8tsB1Hs5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_ec45ee8647524a047caff21c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "The Tavern at Lakeside",
      "poi_type": "Restaurants",
      "poi_address": "2600 Lakeside Pkwy #100, Flower Mound, TX 75022, USA",
      "poi_short_description": "Spacious, low-key eatery featuring burgers, fish and chips and brunch on weekends in relaxed quarters.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-acc4-7739-87cf-2877e05a662c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-acc4-7739-87cf-2877e05a662c",
        "storage_key": "property/5657559276978176/019f14ec-acc4-7739-87cf-2877e05a662c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tavernlakesideflowermound.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8751450699336834317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-tavern-at-lakeside",
      "poi_latitude": "32.9933068",
      "poi_longitude": "-97.0673785",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 469-200-6533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFWJQsJotTIYRDd1QOwtmc3k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_6aa564ed160046260b3d751a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Mio Nonno Trattoria",
      "poi_type": "Restaurants",
      "poi_address": "2450 Lakeside Pkwy #4 #100, Flower Mound, TX 75022, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-b1d7-725b-858d-a1b630fe557a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-b1d7-725b-858d-a1b630fe557a",
        "storage_key": "property/5657559276978176/019f14ec-b1d7-725b-858d-a1b630fe557a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://miononno.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15909380945868399683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mio-nonno-trattoria",
      "poi_latitude": "32.9942772",
      "poi_longitude": "-97.0652244",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 469-804-7472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYb87iOwsTIYRQ6Tawq15ydw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_ce86bf5e91a31b0b891087ff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Clink Wine Bar + Bites",
      "poi_type": "Restaurants",
      "poi_address": "2601 Lakeside Pkwy #100, Flower Mound, TX 75022, USA",
      "poi_short_description": "Wines, cocktails, beer and tapas are served at this eatery and bar which features wine on tap.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-adbb-7265-a98a-609fd202fe5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-adbb-7265-a98a-609fd202fe5a",
        "storage_key": "property/5657559276978176/019f14ec-adbb-7265-a98a-609fd202fe5a.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.clinkwinebarandbites.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127006994618525848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clink-wine-bar--bites",
      "poi_latitude": "32.9928584",
      "poi_longitude": "-97.0671581",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 469-240-1660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLeYApBstTIYRmChOzk9_LLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_d10f957f385a14f43833b625",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Chante Mexican Grill & Cantina",
      "poi_type": "Restaurants",
      "poi_address": "951 W Round Grove Rd #200, Lewisville, TX 75067, USA",
      "poi_short_description": "Mexican eatery serving familiar favorites such as enchiladas and tacos plus a range of margaritas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-b1de-7644-a0a5-c2a735f11289.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-b1de-7644-a0a5-c2a735f11289",
        "storage_key": "property/5657559276978176/019f14ec-b1de-7644-a0a5-c2a735f11289.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chantemexicangrilltx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5107239488674644045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chante-mexican-grill--cantina",
      "poi_latitude": "33.0064979",
      "poi_longitude": "-97.0133772",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 469-293-8098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhyte8eMtTIYRTcBMcUGP4EY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_e3b3307dfc072237a1893122",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "724 Hebron Pkwy @, Lakeside Cir, Lewisville, TX 75057, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-b1df-7176-a70b-f0e62fd2e0e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-b1df-7176-a70b-f0e62fd2e0e9",
        "storage_key": "property/5657559276978176/019f14ec-b1df-7176-a70b-f0e62fd2e0e9.webp",
        "width": 1280,
        "height": 954
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/lewisville/724-hebron-parkway-33120?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3402059581431319601&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "33.0097493",
      "poi_longitude": "-96.9677248",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 972-459-5181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ed-49fe-767a-b834-789f761d106d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-49fe-767a-b834-789f761d106d",
        "storage_key": "property/5657559276978176/019f14ed-49fe-767a-b834-789f761d106d.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJbcgmwPwuTIYRMYztFyqLNi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_256a75c3c5137a086927b92c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "725 Hebron Pkwy, Lewisville, TX 75057, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-b1de-7644-a0a5-bd0a816f640b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-b1de-7644-a0a5-bd0a816f640b",
        "storage_key": "property/5657559276978176/019f14ec-b1de-7644-a0a5-bd0a816f640b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/vista-ridge/1395",
      "poi_directions_map_url": "https://maps.google.com/?cid=10546068746094317387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "33.0124667",
      "poi_longitude": "-96.9714149",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-459-2605",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4cc4-71b1-9e1a-2fb68a89e905.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4cc4-71b1-9e1a-2fb68a89e905",
        "storage_key": "property/5657559276978176/019f14e9-4cc4-71b1-9e1a-2fb68a89e905.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz7GNvfsuTIYRSw_NK6YpW5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_2ff5717007b977709f21ec5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Zion Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2405 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Open, airy market featuring a variety of Asian grocery items, produce & counter-serve prepared fare.",
      "poi_long_description": "Open, airy market featuring a variety of Asian grocery items, produce & counter-serve prepared fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e8-bbd4-70ea-8858-4bdb4d844fe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-bbd4-70ea-8858-4bdb4d844fe7",
        "storage_key": "property/5657559276978176/019f14e8-bbd4-70ea-8858-4bdb4d844fe7.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://zionmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10912467038792319824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zion-market",
      "poi_latitude": "33.0032808",
      "poi_longitude": "-96.9706213",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 469-637-0070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4caf-720f-9248-2737aab7afbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4caf-720f-9248-2737aab7afbe",
        "storage_key": "property/5657559276978176/019f14e9-4caf-720f-9248-2737aab7afbe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUaG-qdIvTIYRUANgfvTecJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "ec_5d72dffe7b058a7d94bce32b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Tom Thumb",
      "poi_type": "Shopping & Retail",
      "poi_address": "1075 FM3040, Lewisville, TX 75067, USA",
      "poi_short_description": "Clean neighborhood supermarket chain known for its bakery, deli and in-store pharmacy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-b565-73a8-a7bd-77f38b8bbc05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-b565-73a8-a7bd-77f38b8bbc05",
        "storage_key": "property/5657559276978176/019f14ec-b565-73a8-a7bd-77f38b8bbc05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://local.tomthumb.com/tx/lewisville/1075-w-fm3040.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14065001044410346746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb",
      "poi_latitude": "33.0067429",
      "poi_longitude": "-97.0169006",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-488-3060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4caf-720f-9248-2737aab7afbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4caf-720f-9248-2737aab7afbe",
        "storage_key": "property/5657559276978176/019f14e9-4caf-720f-9248-2737aab7afbe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8Dh-S8sTIYR-qyTKe7rMMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_b6acc1af2ab4234492193d47",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "Wide-ranging retailer offering merchandise from clothing and home furnishings to baby gear and electronics.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-b6ae-727d-82ec-8cdac223840d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-b6ae-727d-82ec-8cdac223840d",
        "storage_key": "property/5657559276978176/019f14ec-b6ae-727d-82ec-8cdac223840d.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/217-lewisville-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16029587974392983813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.0471863",
      "poi_longitude": "-97.0140609",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-436-3099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4cc4-71b1-9e1a-2fb68a89e905.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4cc4-71b1-9e1a-2fb68a89e905",
        "storage_key": "property/5657559276978176/019f14e9-4cc4-71b1-9e1a-2fb68a89e905.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu-S5aeQtTIYRBTGRlVWJdN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_9ad95a08d65e1ebd55932bcc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1585 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-b7dd-71e6-9689-8e94fe8a6963.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-b7dd-71e6-9689-8e94fe8a6963",
        "storage_key": "property/5657559276978176/019f14ec-b7dd-71e6-9689-8e94fe8a6963.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/tx/lewisville/1585-w-main-st/l842",
      "poi_directions_map_url": "https://maps.google.com/?cid=10397881760231869846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "33.04255",
      "poi_longitude": "-97.03503",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4caf-720f-9248-2737aab7afbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4caf-720f-9248-2737aab7afbe",
        "storage_key": "property/5657559276978176/019f14e9-4caf-720f-9248-2737aab7afbe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK1QcwpYtTIYRlk0i316yTJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_8d6ae5af3b814425b9c614c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1099 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-b700-715f-8363-c9a8d9f3d71d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-b700-715f-8363-c9a8d9f3d71d",
        "storage_key": "property/5657559276978176/019f14ec-b700-715f-8363-c9a8d9f3d71d.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/lewisville-tx-pharmacies/1099-w-main-st-lewisville-tx-75067/storeid=6865?WT.mc_id=LS_GOOGLE_RX_6865",
      "poi_directions_map_url": "https://maps.google.com/?cid=4754155902935122162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.0425905",
      "poi_longitude": "-97.0202272",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-436-3553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ed-49f5-747c-822e-760342f22303.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-49f5-747c-822e-760342f22303",
        "storage_key": "property/5657559276978176/019f14ed-49f5-747c-822e-760342f22303.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5RCo4-gtTIYR8kBG6Zon-kE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_6125320990d31e19af336b91",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1103 FM3040, Lewisville, TX 75067, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-b8f0-7009-bf80-b1cba819578a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-b8f0-7009-bf80-b1cba819578a",
        "storage_key": "property/5657559276978176/019f14ec-b8f0-7009-bf80-b1cba819578a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1103+w+round+grove+rd-lewisville-tx-75067/id=5960",
      "poi_directions_map_url": "https://maps.google.com/?cid=13285167060475715721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.0066963",
      "poi_longitude": "-97.0198397",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-488-8680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1UyEbTAsTIYRiSBgvQ1lXrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_5a283f8c662f98a03d98d418",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Palms African food mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "880 Hebron Pkwy #160, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-bb34-770d-9a72-dc6e1acbbe0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-bb34-770d-9a72-dc6e1acbbe0b",
        "storage_key": "property/5657559276978176/019f14ec-bb34-770d-9a72-dc6e1acbbe0b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.palmsfood.company/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5429596992488033161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palms-african-food-mart",
      "poi_latitude": "33.0123732",
      "poi_longitude": "-96.9628974",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 214-484-7452",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4caf-720f-9248-2737aab7afbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4caf-720f-9248-2737aab7afbe",
        "storage_key": "property/5657559276978176/019f14e9-4caf-720f-9248-2737aab7afbe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzTNJeFwlTIYRiUvHirLNWUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_71fe6a5c078812f4b6574a5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Spec's Wines, Spirits & Finer Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2416 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Family-owned chain retailer with a large selection of wine, liquor & beer, plus snacks.",
      "poi_long_description": "Family-owned chain retailer with a large selection of wine, liquor & beer, plus snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-bfab-7122-a21a-fc38c1b98e84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-bfab-7122-a21a-fc38c1b98e84",
        "storage_key": "property/5657559276978176/019f14ec-bfab-7122-a21a-fc38c1b98e84.webp",
        "width": 1280,
        "height": 908
      },
      "poi_business_url": "https://specsonline.com/liquor-stores/lewisville/lewisville-167/?utm_source=GMBlisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=7066886693245913495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "specs-wines-spirits--finer-foods",
      "poi_latitude": "33.0068472",
      "poi_longitude": "-96.9681563",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 214-488-0888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4cc4-71b1-9e1a-2fb68a89e905.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4cc4-71b1-9e1a-2fb68a89e905",
        "storage_key": "property/5657559276978176/019f14e9-4cc4-71b1-9e1a-2fb68a89e905.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDWygaeMuTIYRl4nbagGgEmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "liquor_store"
    },
    {
      "id": "ec_b64eff2a648929fb5cf9a09b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Mill Street Elementary School",
      "poi_type": "Education",
      "poi_address": "601 S Mill St, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-bf4e-777a-ab00-d7a0986a8659.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-bf4e-777a-ab00-d7a0986a8659",
        "storage_key": "property/5657559276978176/019f14ec-bf4e-777a-ab00-d7a0986a8659.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.lisd.net/millstreet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16071486801879597452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mill-street-elementary-school",
      "poi_latitude": "33.0411591",
      "poi_longitude": "-96.9941284",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-713-5965",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c55-754e-8b30-79f157bfdd80",
        "storage_key": "property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2TA92FgvTIYRjIFpjhhkCd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_b1263f81b321f164a827d33d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Central Elementary School",
      "poi_type": "Education",
      "poi_address": "400 High School Dr, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7919267620850599424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-elementary-school",
      "poi_latitude": "33.0393186",
      "poi_longitude": "-96.9990856",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 469-713-5976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c55-754e-8b30-79f157bfdd80",
        "storage_key": "property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz6KfqgwuTIYRAIYNbvHj5m0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_5392b8d049c61f9bff265c41",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "DeLay Middle School",
      "poi_type": "Education",
      "poi_address": "2103 Savage Ln, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lisd.net/Domain/52",
      "poi_directions_map_url": "https://maps.google.com/?cid=1314872000791363512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delay-middle-school",
      "poi_latitude": "33.0742795",
      "poi_longitude": "-97.0193521",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-713-5191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c55-754e-8b30-79f157bfdd80",
        "storage_key": "property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb8lDQBAyTIYRuL9GRB5dPxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_e76804703267e9dec992df09",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Lewisville High School",
      "poi_type": "Education",
      "poi_address": "1098 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-bafa-70df-9fb3-473645316a02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-bafa-70df-9fb3-473645316a02",
        "storage_key": "property/5657559276978176/019f14ec-bafa-70df-9fb3-473645316a02.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://www.lisd.net/lhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=13217418244982932091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-high-school",
      "poi_latitude": "33.0402359",
      "poi_longitude": "-97.0192205",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-713-5190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c55-754e-8b30-79f157bfdd80",
        "storage_key": "property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMzpudugtTIYRe4L5a92zbbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_23ad03e5dd6531190022c330",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "The Colony High School",
      "poi_type": "Education",
      "poi_address": "4301 Blair Oaks Dr, The Colony, TX 75056, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-bb99-720e-b300-49a9a4ee0bd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-bb99-720e-b300-49a9a4ee0bd3",
        "storage_key": "property/5657559276978176/019f14ec-bb99-720e-b300-49a9a4ee0bd3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tchs.lisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16032264007466296396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-colony-high-school",
      "poi_latitude": "33.0755045",
      "poi_longitude": "-96.8858921",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 469-713-5178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c55-754e-8b30-79f157bfdd80",
        "storage_key": "property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJI2mSdtE6TIYRTCRPFiwLft4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_959ed681db3aba55c9296afd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Winfree Academy Charter School",
      "poi_type": "Education",
      "poi_address": "341 Bennett Ln, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.winfreeacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7760737497248775398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "winfree-academy-charter-school",
      "poi_latitude": "33.0279139",
      "poi_longitude": "-96.9890483",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 214-222-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c55-754e-8b30-79f157bfdd80",
        "storage_key": "property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvWcvR2YuTIYR5jyRtqKts2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_fbe5b8ea7760a67a4006ba97",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Lakeland Christian Academy",
      "poi_type": "Education",
      "poi_address": "397 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-bb94-721a-a6e9-22f41a08f3a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-bb94-721a-a6e9-22f41a08f3a4",
        "storage_key": "property/5657559276978176/019f14ec-bb94-721a-a6e9-22f41a08f3a4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lakelandchristianacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7495180637786810927&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakeland-christian-academy",
      "poi_latitude": "33.0436226",
      "poi_longitude": "-97.0085784",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-219-3939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c55-754e-8b30-79f157bfdd80",
        "storage_key": "property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSwLOweEtTIYRLyqrMhQ7BGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_925ef5e85a7dd9eb5cb21e8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "OurKids Montessori School & Child Care Center",
      "poi_type": "Education",
      "poi_address": "477 Highland Dr, Lewisville, TX 75067, USA",
      "poi_short_description": "Childcare center and Montessori school providing education for infants, toddlers, and preschoolers.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-bf1f-76cc-89cf-493e39048ff4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-bf1f-76cc-89cf-493e39048ff4",
        "storage_key": "property/5657559276978176/019f14ec-bf1f-76cc-89cf-493e39048ff4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ourkidsmontessori.com/contact-us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7159800906016463611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ourkids-montessori-school--child-care-center",
      "poi_latitude": "32.9945232",
      "poi_longitude": "-96.9782294",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-318-2932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c55-754e-8b30-79f157bfdd80",
        "storage_key": "property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvfO-RcIuTIYR-5qhYf24XGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_d53dd9758405f930ee077015",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Quail Valley Childcare Center",
      "poi_type": "Education",
      "poi_address": "662 Edmonds Ln, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1981819017299512191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quail-valley-childcare-center",
      "poi_latitude": "33.0403291",
      "poi_longitude": "-97.010437",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c55-754e-8b30-79f157bfdd80",
        "storage_key": "property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBZ3fluAtTIYRf0tAZ-XVgBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_eb570d73faaa9a5fe1a4cbbd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Maple Bear Lewisville",
      "poi_type": "Education",
      "poi_address": "950 N Garden Ridge Blvd, Lewisville, TX 75077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-c10c-77ee-831d-dba19f2af8c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-c10c-77ee-831d-dba19f2af8c5",
        "storage_key": "property/5657559276978176/019f14ec-c10c-77ee-831d-dba19f2af8c5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://lewisville.maplebearusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2833414984030599048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maple-bear-lewisville",
      "poi_latitude": "33.054577",
      "poi_longitude": "-97.036295",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 214-222-5425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c55-754e-8b30-79f157bfdd80",
        "storage_key": "property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_4qpGc8tTIYRiLdpeOpPUic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_0f450c9a099b62d9cadc7244",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Cinemark Lewisville and XD",
      "poi_type": "Entertainment",
      "poi_address": "2401 S Stemmons Fwy, Lewisville, TX 75067, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-c24e-723c-b70d-20955310a32a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-c24e-723c-b70d-20955310a32a",
        "storage_key": "property/5657559276978176/019f14ec-c24e-723c-b70d-20955310a32a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-lewisville/cinemark-lewisville-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5NTAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5421992385327197290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-lewisville-and-xd",
      "poi_latitude": "33.0015458",
      "poi_longitude": "-96.9707528",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-315-6152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ed-4a38-76dc-88b8-35596c7ebce5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4a38-76dc-88b8-35596c7ebce5",
        "storage_key": "property/5657559276978176/019f14ed-4a38-76dc-88b8-35596c7ebce5.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJqwew-uMuTIYRauxM9ljJPks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_140df8715dc1d8a6a8de93ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Lewisville Grand Theater",
      "poi_type": "Entertainment",
      "poi_address": "100 N Charles St, Lewisville, TX 75057, USA",
      "poi_short_description": "Spacious, contemporary venue featuring theater performances, events & classes, plus an art gallery.",
      "poi_long_description": "Spacious, contemporary venue featuring theater performances, events & classes, plus an art gallery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-c364-743f-b3cb-6f6a0207ffb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-c364-743f-b3cb-6f6a0207ffb4",
        "storage_key": "property/5657559276978176/019f14ec-c364-743f-b3cb-6f6a0207ffb4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lewisvillegrand.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9286174857949251761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-grand-theater",
      "poi_latitude": "33.0467948",
      "poi_longitude": "-96.9972686",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-219-8446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWaEPBA4uTIYRsYg6QtUe34A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_f7c14f3c16645386f07a96b0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Wayne Ferguson Plaza",
      "poi_type": "Entertainment",
      "poi_address": "150 W Church St, Lewisville, TX 75057, USA",
      "poi_short_description": "Relaxed gathering spot for festivals and concerts in the summer and free fitness classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-c378-7738-ab26-f0e81f2fb32a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-c378-7738-ab26-f0e81f2fb32a",
        "storage_key": "property/5657559276978176/019f14ec-c378-7738-ab26-f0e81f2fb32a.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/wayne-ferguson-plaza",
      "poi_directions_map_url": "https://maps.google.com/?cid=15692859072330310905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wayne-ferguson-plaza",
      "poi_latitude": "33.0471824",
      "poi_longitude": "-96.9956036",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-219-3401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d0f-761d-9b03-2ed371414659",
        "storage_key": "property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-gW5BEuTIYR-aSDlC48yNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_37685fa3550daca9507376dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Lake Park",
      "poi_type": "Entertainment",
      "poi_address": "600 Sandy Beach Rd, Lewisville, TX 75057, USA",
      "poi_short_description": "Recreational park offering lake swimming & boating, a golf course, athletic fields & picnic areas.",
      "poi_long_description": "Recreational park offering lake swimming & boating, a golf course, athletic fields & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-c570-76bc-b4b9-1ad5443e9fe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-c570-76bc-b4b9-1ad5443e9fe2",
        "storage_key": "property/5657559276978176/019f14ec-c570-76bc-b4b9-1ad5443e9fe2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3830431707728878479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-park",
      "poi_latitude": "33.0770484",
      "poi_longitude": "-97.0066054",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d0f-761d-9b03-2ed371414659",
        "storage_key": "property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNevF6_cxTIYRj5uS-1dtKDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_26d7e87e3dd127896754e646",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "LLELA Nature Preserve",
      "poi_type": "Entertainment",
      "poi_address": "201 E Jones St, Lewisville, TX 75057, USA",
      "poi_short_description": "Scenic nature preserve offering a visitor center, walking trails, fishing, camping, kayaking & more.",
      "poi_long_description": "Scenic nature preserve offering a visitor center, walking trails, fishing, camping, kayaking & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-c7cc-725e-a505-c5a1053259a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-c7cc-725e-a505-c5a1053259a1",
        "storage_key": "property/5657559276978176/019f14ec-c7cc-725e-a505-c5a1053259a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.llela.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11336426955797826332&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "llela-nature-preserve",
      "poi_latitude": "33.0638972",
      "poi_longitude": "-96.9922426",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d0f-761d-9b03-2ed371414659",
        "storage_key": "property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7_GUP8xTIYRHAt-2kAUU50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_d832b4584005465ef3f47d3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "BENDT Distilling Co.",
      "poi_type": "Entertainment",
      "poi_address": "225 S Charles St, Lewisville, TX 75057, USA",
      "poi_short_description": "Stylish distillery featuring handcrafted whiskies, guided tours, a craft cocktail bar & live music.",
      "poi_long_description": "Stylish distillery featuring handcrafted whiskies, guided tours, a craft cocktail bar & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-c56f-7195-a032-4b9767c50794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-c56f-7195-a032-4b9767c50794",
        "storage_key": "property/5657559276978176/019f14ec-c56f-7195-a032-4b9767c50794.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.bendtdistillingco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11360244417594972231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bendt-distilling-co",
      "poi_latitude": "33.0447239",
      "poi_longitude": "-96.9972219",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 214-814-0545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ66d6GgYuTIYRR9hc0Buyp50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_2b519ac1c08bded957caeba9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Andretti Indoor Karting & Games The Colony",
      "poi_type": "Entertainment",
      "poi_address": "5752 Grandscape Blvd Ste 100, The Colony, TX 75056, USA",
      "poi_short_description": "Arcade featuring go-karts, bowling and laser tag, plus a track for electric superkarts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-c75c-7648-af7f-bd099e697870.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-c75c-7648-af7f-bd099e697870",
        "storage_key": "property/5657559276978176/019f14ec-c75c-7648-af7f-bd099e697870.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://andrettikarting.com/thecolony/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8539956745447602546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andretti-indoor-karting--games-the-colony",
      "poi_latitude": "33.0742492",
      "poi_longitude": "-96.8611526",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-527-3278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRzZVK6A7TIYRcvma0WkFhHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_3f716da17f08c20eb72a0976",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Topgolf The Colony",
      "poi_type": "Entertainment",
      "poi_address": "3760 Blair Oaks Dr, The Colony, TX 75056, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e8-bbc1-747b-8059-4b63e2f0f3f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-bbc1-747b-8059-4b63e2f0f3f0",
        "storage_key": "property/5657559276978176/019f14e8-bbc1-747b-8059-4b63e2f0f3f0.webp",
        "width": 980,
        "height": 653
      },
      "poi_business_url": "https://topgolf.com/us/the-colony/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12559740388646950382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-the-colony",
      "poi_latitude": "33.0703613",
      "poi_longitude": "-96.8837492",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-213-5204",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4b38-740f-9bc1-3d7ddede95b4",
        "storage_key": "property/5657559276978176/019f14e9-4b38-740f-9bc1-3d7ddede95b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlbpTPNM6TIYR7pVt0FYpTa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_6cfb23ae3cdb41944200a494",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Celebration Escape Rooms",
      "poi_type": "Entertainment",
      "poi_address": "1992 Justin Rd #200, Lewisville, TX 75077, USA",
      "poi_short_description": "Kid-friendly venue featuring private puzzle rooms and birthday parties.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-c942-72bd-9351-df3e0259051d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-c942-72bd-9351-df3e0259051d",
        "storage_key": "property/5657559276978176/019f14ec-c942-72bd-9351-df3e0259051d.webp",
        "width": 397,
        "height": 483
      },
      "poi_business_url": "https://celebrationescaperooms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5857341721767845723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "celebration-escape-rooms",
      "poi_latitude": "33.0720492",
      "poi_longitude": "-97.0506467",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 214-414-2031",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY4AlOm4zTIYRWx8MLkN1SVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_5022daf4cea626e90d8c953b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Dimensions Escape Rooms - Lewisville",
      "poi_type": "Entertainment",
      "poi_address": "1720 Edmonds Ln Ste 216, Lewisville, TX 75067, USA",
      "poi_short_description": "Amusement center offering escape rooms with modern themes, special effects, and family-friendly options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-cba3-76b8-8dc5-74c0f678cd32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-cba3-76b8-8dc5-74c0f678cd32",
        "storage_key": "property/5657559276978176/019f14ec-cba3-76b8-8dc5-74c0f678cd32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.escapedimensions.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3623011267539022383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dimensions-escape-rooms---lewisville",
      "poi_latitude": "33.0226838",
      "poi_longitude": "-97.0124653",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 940-999-8792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBazhLvEtTIYRL7LmYo2FRzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_325fb928e1729f44488997ce",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Medical City Lewisville",
      "poi_type": "Health and Wellness",
      "poi_address": "500 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e8-f1ce-74fe-803c-cd44189126e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-f1ce-74fe-803c-cd44189126e7",
        "storage_key": "property/5657559276978176/019f14e8-f1ce-74fe-803c-cd44189126e7.webp",
        "width": 493,
        "height": 277
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-lewisville-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=2514616797377254311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-lewisville",
      "poi_latitude": "33.0454235",
      "poi_longitude": "-97.0049828",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 469-370-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c52-773e-85fc-a360e4589de3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c52-773e-85fc-a360e4589de3",
        "storage_key": "property/5657559276978176/019f14e9-4c52-773e-85fc-a360e4589de3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJC-CoNgouTIYRp9Pmeae25SI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_d79ab1219ec4975fa544fff5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Baylor Scott & White Urgent Care+ Lewisville",
      "poi_type": "Health and Wellness",
      "poi_address": "540 Surf St, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-c900-7397-9b92-f1b68c882508.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-c900-7397-9b92-f1b68c882508",
        "storage_key": "property/5657559276978176/019f14ec-c900-7397-9b92-f1b68c882508.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bswhealth.com/locations/urgent-care/uc-plus-lewisville?utm_source=google-mybusiness&utm_medium=organic&utm_campaign=UC+Lewisville&utm_content=main-website",
      "poi_directions_map_url": "https://maps.google.com/?cid=6204775221569807245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-urgent-care-lewisville",
      "poi_latitude": "33.0439583",
      "poi_longitude": "-97.0144103",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-420-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbfW9juYtTIYRjWPQkDDKG1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_a39eb34e68841e051fdf505e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - Lewisville",
      "poi_type": "Health and Wellness",
      "poi_address": "1559 W Main St, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-ca1c-73b8-ae2c-42188c8d3b82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-ca1c-73b8-ae2c-42188c8d3b82",
        "storage_key": "property/5657559276978176/019f14ec-ca1c-73b8-ae2c-42188c8d3b82.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/dallas-fort-worth/lewisville?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11104618521802294127&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---lewisville",
      "poi_latitude": "33.0426704",
      "poi_longitude": "-97.0313202",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-436-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5Rz9l5YtTIYRb8M_9rWHG5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_86f1f862ee5c74ea167e6653",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "725 Hebron Pkwy, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-cd8a-71a8-998f-432ab3177209.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-cd8a-71a8-998f-432ab3177209",
        "storage_key": "property/5657559276978176/019f14ec-cd8a-71a8-998f-432ab3177209.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/lewisville-tx-pharmacies/725-hebron-pkwy-lewisville-tx-75057/storeid=16734?WT.mc_id=LS_GOOGLE_RX_16734",
      "poi_directions_map_url": "https://maps.google.com/?cid=12705969126711005934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.0123273",
      "poi_longitude": "-96.9711537",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-459-5906",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ed-49f5-747c-822e-760342f22303.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-49f5-747c-822e-760342f22303",
        "storage_key": "property/5657559276978176/019f14ed-49f5-747c-822e-760342f22303.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIU6JvfsuTIYR7pKwBJqrVLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_1795a86a9587b9d9dd147c79",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4620 State Hwy 121, Lewisville, TX 75056, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-cba7-7758-8eee-391556718b1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-cba7-7758-8eee-391556718b1d",
        "storage_key": "property/5657559276978176/019f14ec-cba7-7758-8eee-391556718b1d.webp",
        "width": 796,
        "height": 503
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/035/00599?cid=loc_03500599P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12195138954507529151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "33.0621439",
      "poi_longitude": "-96.8890929",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-535-2480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ed-49f5-747c-822e-760342f22303.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-49f5-747c-822e-760342f22303",
        "storage_key": "property/5657559276978176/019f14ed-49f5-747c-822e-760342f22303.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ08Zx5DElTIYRvyvzOUTWPak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_4d4a033cc76b476e5996908c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Luxe Med Compounding Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "560 W Main St Ste 105, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-d056-73b9-9dd7-f0026fb4b955.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-d056-73b9-9dd7-f0026fb4b955",
        "storage_key": "property/5657559276978176/019f14ec-d056-73b9-9dd7-f0026fb4b955.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.luxemedpharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16543261547020519515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "luxe-med-compounding-pharmacy",
      "poi_latitude": "33.0459714",
      "poi_longitude": "-97.00661490000002",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-906-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ed-49f5-747c-822e-760342f22303.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-49f5-747c-822e-760342f22303",
        "storage_key": "property/5657559276978176/019f14ed-49f5-747c-822e-760342f22303.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBaxi-wkuTIYRW4iJILp4leU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_51c75791382e6068ad433532",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "798 E Vista Ridge Mall Dr, Lewisville, TX 75067, USA",
      "poi_short_description": "Chain health club offering cardio and strength equipment, plus group classes, and pools.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e8-e141-758c-8e1d-6b2fb6a5cc90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-e141-758c-8e1d-6b2fb6a5cc90",
        "storage_key": "property/5657559276978176/019f14e8-e141-758c-8e1d-6b2fb6a5cc90.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=334&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12745807886122409510&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.0005792",
      "poi_longitude": "-96.9650374",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-315-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt5FFyOEuTIYRJt6yA7404rA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_a8eb551537d8c357f83e081a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "500 E Round Grove Rd #201, Lewisville, TX 75067, USA",
      "poi_short_description": "Chain fitness center offering a variety of equipment, massage chairs, and tanning beds in a welcoming setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e8-e98f-74a0-b83d-9f7f63d29049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-e98f-74a0-b83d-9f7f63d29049",
        "storage_key": "property/5657559276978176/019f14e8-e98f-74a0-b83d-9f7f63d29049.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/lewisville-round-grove-rd-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15866743250462238426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.0030498",
      "poi_longitude": "-96.9765312",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-293-2215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpYXxAXAuTIYR2uYgsuv-Mdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_7ea84699c5410873c09a691a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Fit Appeal Studios | Fitness Nutrition Yoga Pilates Lewisville",
      "poi_type": "Health and Wellness",
      "poi_address": "817 S Mill St #110, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-d118-74a0-a1c5-6eff5b63612c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-d118-74a0-a1c5-6eff5b63612c",
        "storage_key": "property/5657559276978176/019f14ec-d118-74a0-a1c5-6eff5b63612c.webp",
        "width": 1171,
        "height": 659
      },
      "poi_business_url": "https://www.fit-appeal.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10383249150759462355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fit-appeal-studios--fitness-nutrition-yoga-pilates-lewisville",
      "poi_latitude": "33.0381315",
      "poi_longitude": "-96.9932532",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-312-0657",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ58E5_GwuTIYR0-Vk_Ra2GJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_5c90a88b030f62e6f326329d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Blue Anjou Yoga Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "427 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "Cozy yoga studio offering a variety of classes and teacher training programs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-d0b0-76df-a0ad-4016c14c60d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-d0b0-76df-a0ad-4016c14c60d3",
        "storage_key": "property/5657559276978176/019f14ec-d0b0-76df-a0ad-4016c14c60d3.webp",
        "width": 864,
        "height": 473
      },
      "poi_business_url": "http://www.blueanjou.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13912147855743026414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-anjou-yoga-studio",
      "poi_latitude": "33.0465534",
      "poi_longitude": "-97.0022612",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-645-8555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c55-754e-8b30-79f157bfdd80",
        "storage_key": "property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEXbfRQkuTIYR7oRG3MPgEcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_8cfa94d318e352501bafffaa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "LLELA Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 E Jones St, Lewisville, TX 75057, USA",
      "poi_short_description": "Scenic nature preserve offering a visitor center, walking trails, fishing, camping, kayaking & more.",
      "poi_long_description": "Scenic nature preserve offering a visitor center, walking trails, fishing, camping, kayaking & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-c7cc-725e-a505-c5a1053259a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-c7cc-725e-a505-c5a1053259a1",
        "storage_key": "property/5657559276978176/019f14ec-c7cc-725e-a505-c5a1053259a1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.llela.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11336426955797826332&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "llela-nature-preserve",
      "poi_latitude": "33.0638972",
      "poi_longitude": "-96.9922426",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d0f-761d-9b03-2ed371414659",
        "storage_key": "property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7_GUP8xTIYRHAt-2kAUU50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_db12edd6a670cca8d0b1ec80",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 Sandy Beach Rd, Lewisville, TX 75057, USA",
      "poi_short_description": "Recreational park offering lake swimming & boating, a golf course, athletic fields & picnic areas.",
      "poi_long_description": "Recreational park offering lake swimming & boating, a golf course, athletic fields & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-c570-76bc-b4b9-1ad5443e9fe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-c570-76bc-b4b9-1ad5443e9fe2",
        "storage_key": "property/5657559276978176/019f14ec-c570-76bc-b4b9-1ad5443e9fe2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3830431707728878479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-park",
      "poi_latitude": "33.0770484",
      "poi_longitude": "-97.0066054",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d0f-761d-9b03-2ed371414659",
        "storage_key": "property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNevF6_cxTIYRj5uS-1dtKDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_afd9fc732cc3c5f403494755",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Tower Bay Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3000 N Stemmons Fwy, Lewisville, TX 75077, USA",
      "poi_short_description": "Public park on Lewisville Lake with a concrete boat ramp & access to a lakeside hiking/biking trail.",
      "poi_long_description": "Public park on Lewisville Lake with a concrete boat ramp & access to a lakeside hiking/biking trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-d3e0-7420-af9d-5abb27657006.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-d3e0-7420-af9d-5abb27657006",
        "storage_key": "property/5657559276978176/019f14ec-d3e0-7420-af9d-5abb27657006.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/tower-bay",
      "poi_directions_map_url": "https://maps.google.com/?cid=15412102371035193294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tower-bay-park",
      "poi_latitude": "33.0873651",
      "poi_longitude": "-97.025561",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d0f-761d-9b03-2ed371414659",
        "storage_key": "property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ80BnojkyTIYRzh-CG3PJ4tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5a985f748165d9628ce55983",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Lewisville Railroad Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1301 Bennett Ln, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-134b-7074-829a-66b4189adffe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-134b-7074-829a-66b4189adffe",
        "storage_key": "property/5657559276978176/019f14e9-134b-7074-829a-66b4189adffe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/railroad-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9888952657572346167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-railroad-park",
      "poi_latitude": "33.0280711",
      "poi_longitude": "-96.9717402",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-219-5077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d0f-761d-9b03-2ed371414659",
        "storage_key": "property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ0OL9lAuTIYRNzlBUwyePIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_18073583eb498816fd8ac8fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Wayne Ferguson Plaza",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "150 W Church St, Lewisville, TX 75057, USA",
      "poi_short_description": "Relaxed gathering spot for festivals and concerts in the summer and free fitness classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-c378-7738-ab26-f0e81f2fb32a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-c378-7738-ab26-f0e81f2fb32a",
        "storage_key": "property/5657559276978176/019f14ec-c378-7738-ab26-f0e81f2fb32a.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/wayne-ferguson-plaza",
      "poi_directions_map_url": "https://maps.google.com/?cid=15692859072330310905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wayne-ferguson-plaza",
      "poi_latitude": "33.0471824",
      "poi_longitude": "-96.9956036",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-219-3401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d0f-761d-9b03-2ed371414659",
        "storage_key": "property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-gW5BEuTIYR-aSDlC48yNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_c250a0df83e26a2245ba51f4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Old Town Lewisville",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-d3cd-77bc-805e-133d587cd370.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-d3cd-77bc-805e-133d587cd370",
        "storage_key": "property/5657559276978176/019f14ec-d3cd-77bc-805e-133d587cd370.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://oldtownlewisville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16446796901192101447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-town-lewisville",
      "poi_latitude": "33.0466451",
      "poi_longitude": "-96.9939646",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-657-9571",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ed-4a01-7664-994b-8b13f32b7046.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4a01-7664-994b-8b13f32b7046",
        "storage_key": "property/5657559276978176/019f14ed-4a01-7664-994b-8b13f32b7046.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIb7V0rUvTIYRR-6MjKTCPuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_ff24918afbf35e2bbea694a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Lake Avalon Circle",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2590 King Arthur Blvd, Lewisville, TX 75056, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-d4f5-73be-90b1-ac17d4944bd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-d4f5-73be-90b1-ac17d4944bd6",
        "storage_key": "property/5657559276978176/019f14ec-d4f5-73be-90b1-ac17d4944bd6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10263189229886661762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-avalon-circle",
      "poi_latitude": "33.0364199",
      "poi_longitude": "-96.898426",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d0f-761d-9b03-2ed371414659",
        "storage_key": "property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-1teDjslTIYRgmQCVjosbo4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_26af380b26805aaaa1df8bbe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Highland Lakes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Lewisville, TX 75077, USA",
      "poi_short_description": "Park featuring a trail and picnic tables, plus opportunities for fishing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-d822-778c-b23c-d4590d13a530.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-d822-778c-b23c-d4590d13a530",
        "storage_key": "property/5657559276978176/019f14ec-d822-778c-b23c-d4590d13a530.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1059100505647203832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highland-lakes-park",
      "poi_latitude": "33.085883",
      "poi_longitude": "-97.0284355",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d0f-761d-9b03-2ed371414659",
        "storage_key": "property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQMpoqUzTIYR-MWJbEyusg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9bf27436adc5ebda4fde8db0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Meadowlake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1430 Brazos Blvd, Lewisville, TX 75077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-d881-753f-b891-c7a6b1aa0746.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-d881-753f-b891-c7a6b1aa0746",
        "storage_key": "property/5657559276978176/019f14ec-d881-753f-b891-c7a6b1aa0746.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.playlewisville.com/parks/park-listings/meadowlake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6156877141140294943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadowlake-park",
      "poi_latitude": "33.0770955",
      "poi_longitude": "-97.0351763",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 972-219-3550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d0f-761d-9b03-2ed371414659",
        "storage_key": "property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJleE0494zTIYRH81jqyOfcVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d73df21136146848fa58cd39",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Doubletree Ranch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "310 Highland Village Rd, Highland Village, TX 75077, USA",
      "poi_short_description": "Grassy park featuring a splash pad, soccer fields and playgrounds.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-d8ea-7101-b64d-09d0ed3d4bc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-d8ea-7101-b64d-09d0ed3d4bc8",
        "storage_key": "property/5657559276978176/019f14ec-d8ea-7101-b64d-09d0ed3d4bc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.highlandvillage.org/Facilities/Facility/Details/Doubletree-Ranch-Park-17",
      "poi_directions_map_url": "https://maps.google.com/?cid=4536307142516168406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doubletree-ranch-park",
      "poi_latitude": "33.0898855",
      "poi_longitude": "-97.03496",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 972-317-7430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d0f-761d-9b03-2ed371414659",
        "storage_key": "property/5657559276978176/019f14e9-4d0f-761d-9b03-2ed371414659.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8UX1IkQyTIYR1la-zU8z9D4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_31098799562cfd6180e75441",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Hebron Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "952 Lakeside Cir, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-2667-71e8-a9c6-56d008d8f8f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-2667-71e8-a9c6-56d008d8f8f6",
        "storage_key": "property/5657559276978176/019f14e9-2667-71e8-a9c6-56d008d8f8f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dcta.net/images/uploads/content_files/connect_files/1-15-update/route21-1-15.pdf",
      "poi_directions_map_url": "https://maps.google.com/?cid=6216114618958893695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hebron-station",
      "poi_latitude": "33.0101482",
      "poi_longitude": "-96.9584227",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4cb5-743f-9cf7-629f5f8a4798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4cb5-743f-9cf7-629f5f8a4798",
        "storage_key": "property/5657559276978176/019f14e9-4cb5-743f-9cf7-629f5f8a4798.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJby-eZwMvTIYRf1Iowk8TRFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_c5e15b50738d5bf2725da936",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Old Town",
      "poi_type": "Transportation & Transit",
      "poi_address": "617 E Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-21c8-77dc-b550-ebd045dd6657.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-21c8-77dc-b550-ebd045dd6657",
        "storage_key": "property/5657559276978176/019f14e9-21c8-77dc-b550-ebd045dd6657.webp",
        "width": 1280,
        "height": 901
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7239306256237320260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-town",
      "poi_latitude": "33.04736330000001",
      "poi_longitude": "-96.9863475",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4cb5-743f-9cf7-629f5f8a4798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4cb5-743f-9cf7-629f5f8a4798",
        "storage_key": "property/5657559276978176/019f14e9-4cb5-743f-9cf7-629f5f8a4798.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwu6ERYuTIYRRNhJP68ud2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_a13d282f2450b210e00d7e9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Highland Village/Lewisville Lake Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "2998 N Stemmons Fwy, Lewisville, TX 75077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-dd4d-7648-ba88-ffe4e02d8134.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-dd4d-7648-ba88-ffe4e02d8134",
        "storage_key": "property/5657559276978176/019f14ec-dd4d-7648-ba88-ffe4e02d8134.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7343931499598697122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highland-villagelewisville-lake-station",
      "poi_latitude": "33.0834155",
      "poi_longitude": "-97.0259929",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4cb5-743f-9cf7-629f5f8a4798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4cb5-743f-9cf7-629f5f8a4798",
        "storage_key": "property/5657559276978176/019f14e9-4cb5-743f-9cf7-629f5f8a4798.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJh5AgfhUyTIYRotJhAMri6mU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_f92c133919500157b1c8b823",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Downtown Denton Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "604 E Hickory St, Denton, TX 76205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-db49-7589-bac3-2b42ce3acb71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-db49-7589-bac3-2b42ce3acb71",
        "storage_key": "property/5657559276978176/019f14ec-db49-7589-bac3-2b42ce3acb71.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12243141428338983573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-denton-transit-center",
      "poi_latitude": "33.213705",
      "poi_longitude": "-97.126051",
      "poi_miles_from_property": "19.1 mi",
      "poi_walking_minutes": "6 hours 59 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_P6Z43KTYYRlYIDG0Ng6Kk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_b31b38d0b5c758a61c7dc6e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "MedPark Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "3220 Medpark Dr, Denton, TX 76210, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-dbb8-7182-a314-11418191792b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-dbb8-7182-a314-11418191792b",
        "storage_key": "property/5657559276978176/019f14ec-dbb8-7182-a314-11418191792b.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.dcta.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6211726032118505052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medpark-station",
      "poi_latitude": "33.1820209",
      "poi_longitude": "-97.0914304",
      "poi_miles_from_property": "16.7 mi",
      "poi_walking_minutes": "6 hours 7 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 940-243-0077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ed-4a01-7664-994b-86060eca9689.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4a01-7664-994b-86060eca9689",
        "storage_key": "property/5657559276978176/019f14ed-4a01-7664-994b-86060eca9689.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJKx2N0dI0TIYRXF54Qup7NFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_6abec76f60a2a62b22ac048b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Trinity Mills",
      "poi_type": "Transportation & Transit",
      "poi_address": "2525 Blanton Dr, Carrollton, TX 75006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-25be-73f1-9b69-c2921143652d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e9-25be-73f1-9b69-c2921143652d",
        "storage_key": "property/5657559276978176/019f14e9-25be-73f1-9b69-c2921143652d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dart.org/riding/stations/trinitymillsstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=777499669808973001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-mills",
      "poi_latitude": "32.98092",
      "poi_longitude": "-96.9264",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4cb5-743f-9cf7-629f5f8a4798.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4cb5-743f-9cf7-629f5f8a4798",
        "storage_key": "property/5657559276978176/019f14e9-4cb5-743f-9cf7-629f5f8a4798.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJdbbbi1MvTIYRyYTyj9Q7ygo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "ec_6f7e58d881924c9939daaf4f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Denton County Transportation Auth",
      "poi_type": "Transportation & Transit",
      "poi_address": "1955 Lakeway Dr #260, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-e305-760f-8bed-2d2c6eb9fcb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-e305-760f-8bed-2d2c6eb9fcb5",
        "storage_key": "property/5657559276978176/019f14ec-e305-760f-8bed-2d2c6eb9fcb5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.dcta.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16185488412502635099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denton-county-transportation-auth",
      "poi_latitude": "33.0175586",
      "poi_longitude": "-96.9742102",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 940-243-0077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ed-4a01-7664-994b-8b13f32b7046.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4a01-7664-994b-8b13f32b7046",
        "storage_key": "property/5657559276978176/019f14ed-4a01-7664-994b-8b13f32b7046.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHTtSwF8uTIYRW7Jr7_RnnuA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_c71486f6af5ff8df22284d64",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-e04b-744a-84d8-5519ed15bfe4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-e04b-744a-84d8-5519ed15bfe4",
        "storage_key": "property/5657559276978176/019f14ec-e04b-744a-84d8-5519ed15bfe4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 38 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ed-4a28-727d-ac73-2325a048a142.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4a28-727d-ac73-2325a048a142",
        "storage_key": "property/5657559276978176/019f14ed-4a28-727d-ac73-2325a048a142.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_6e49af96977b4ef44dec5ff5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "DFW Airport North TEXRail Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1867 E Dallas Rd, Grapevine, TX 76051, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-dfec-7678-9423-e48f326835d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-dfec-7678-9423-e48f326835d9",
        "storage_key": "property/5657559276978176/019f14ec-dfec-7678-9423-e48f326835d9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ridetrinitymetro.org/stations/dfw-airport-north-station/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6621859291758648515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dfw-airport-north-texrail-station",
      "poi_latitude": "32.9337128",
      "poi_longitude": "-97.0541165",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 817-215-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOV8hQtwrTIYRw9zkFfGR5Vs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_07c14d1347b5ce8a0df9a147",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Medical City Lewisville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 W Main St, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e8-f1ce-74fe-803c-cd44189126e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14e8-f1ce-74fe-803c-cd44189126e7",
        "storage_key": "property/5657559276978176/019f14e8-f1ce-74fe-803c-cd44189126e7.webp",
        "width": 493,
        "height": 277
      },
      "poi_business_url": "https://www.medicalcityhealthcare.com/locations/medical-city-lewisville-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=2514616797377254311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-lewisville",
      "poi_latitude": "33.0454235",
      "poi_longitude": "-97.0049828",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 469-370-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c52-773e-85fc-a360e4589de3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c52-773e-85fc-a360e4589de3",
        "storage_key": "property/5657559276978176/019f14e9-4c52-773e-85fc-a360e4589de3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJC-CoNgouTIYRp9Pmeae25SI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_98dab68dd1896d8b082ca42b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Lewisville Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1565 W Main St #220, Lewisville, TX 75067, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-e6bf-7478-9993-7fa4a3b5923e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-e6bf-7478-9993-7fa4a3b5923e",
        "storage_key": "property/5657559276978176/019f14ec-e6bf-7478-9993-7fa4a3b5923e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.lisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14983067533701921762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-independent-school-district",
      "poi_latitude": "33.0440774",
      "poi_longitude": "-97.035263",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 469-713-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c55-754e-8b30-79f157bfdd80",
        "storage_key": "property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_7CoNZEtTIYR4rv9x4mM7s8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_433032ac0bb2d0733295b7ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Lewisville City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "151 W Church St, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-e128-7688-848b-6ef28cc2a6f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-e128-7688-848b-6ef28cc2a6f1",
        "storage_key": "property/5657559276978176/019f14ec-e128-7688-848b-6ef28cc2a6f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoflewisville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720423613431398683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewisville-city-hall",
      "poi_latitude": "33.0478003",
      "poi_longitude": "-96.9953369",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-219-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ed-4a01-7664-994b-8b13f32b7046.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4a01-7664-994b-8b13f32b7046",
        "storage_key": "property/5657559276978176/019f14ed-4a01-7664-994b-8b13f32b7046.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa5vy7FYvTIYRG8Gtzy1Pp6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_006e777eb310fee15ef6dc18",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Mr. Cooper",
      "poi_type": "Major Employers & Offices",
      "poi_address": "800 State Hwy 121, Lewisville, TX 75067, USA",
      "poi_short_description": "Mortgage lender whose reviews often mention its staff.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mrcooper.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6696476077323968099&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mr-cooper",
      "poi_latitude": "32.9932569",
      "poi_longitude": "-96.9657924",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBVLLpdQvTIYRY97LS4Op7lw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "ec_369ea40c6e3fba739df8a53d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Sysco North Texas - Food Distributor & Restaurant Supplies",
      "poi_type": "Major Employers & Offices",
      "poi_address": "800 Trinity Dr, Lewisville, TX 75056, USA",
      "poi_short_description": "Site used primarily as a warehouse and frequented by trucks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-e754-728c-839b-79d8b3bdf74e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-e754-728c-839b-79d8b3bdf74e",
        "storage_key": "property/5657559276978176/019f14ec-e754-728c-839b-79d8b3bdf74e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cloud.email.sysco.com/become-a-customer?utm_medium=googlemybusiness&utm_source=google.com&utm_campaign=gmb_opcopages&utm_content=north_texas",
      "poi_directions_map_url": "https://maps.google.com/?cid=15800406967313089341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sysco-north-texas---food-distributor--restaurant-supplies",
      "poi_latitude": "33.063622",
      "poi_longitude": "-96.8731515",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 469-384-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0QL6n9YkTIYRPcNNMWxSRts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wholesaler"
    },
    {
      "id": "ec_7c3f154fbe12f43b7646d5c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Texas Health Presbyterian Hospital Flower Mound",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4400 Long Prairie Rd, Flower Mound, TX 75028, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-ecdc-7478-9ac8-d222f73d6e16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-ecdc-7478-9ac8-d222f73d6e16",
        "storage_key": "property/5657559276978176/019f14ec-ecdc-7478-9ac8-d222f73d6e16.webp",
        "width": 1280,
        "height": 792
      },
      "poi_business_url": "https://www.texashealth.org/locations/texas-health-flower-mound",
      "poi_directions_map_url": "https://maps.google.com/?cid=10658615510840280430&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-health-presbyterian-hospital-flower-mound",
      "poi_latitude": "33.0456181",
      "poi_longitude": "-97.0676197",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 469-322-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c52-773e-85fc-a360e4589de3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c52-773e-85fc-a360e4589de3",
        "storage_key": "property/5657559276978176/019f14e9-4c52-773e-85fc-a360e4589de3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6RXXWgtTIYRboUa2VUC65M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_0b9adb1c4dc4df8dd33a9930",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "University of North Texas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1155 Union Cir, Denton, TX 76205, USA",
      "poi_short_description": "Expansive public research university founded in 1890 & known for its music school, among others.",
      "poi_long_description": "Expansive public research university founded in 1890 & known for its music school, among others.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-ebc5-76ac-984c-e8eb64b0d5f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-ebc5-76ac-984c-e8eb64b0d5f7",
        "storage_key": "property/5657559276978176/019f14ec-ebc5-76ac-984c-e8eb64b0d5f7.webp",
        "width": 1280,
        "height": 1002
      },
      "poi_business_url": "https://www.unt.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=846007427916065034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-texas",
      "poi_latitude": "33.2090389",
      "poi_longitude": "-97.153439",
      "poi_miles_from_property": "20.5 mi",
      "poi_walking_minutes": "7 hours 32 mins",
      "poi_biking_minutes": "1 hour 51 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 940-565-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c55-754e-8b30-79f157bfdd80",
        "storage_key": "property/5657559276978176/019f14e9-4c55-754e-8b30-79f157bfdd80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyY815HPKTYYRCmlH-kWfvQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_d18d7e5e8c5a04143c4f9b71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-e9d0-750b-8df5-d8fbc1be6004.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-e9d0-750b-8df5-d8fbc1be6004",
        "storage_key": "property/5657559276978176/019f14ec-e9d0-750b-8df5-d8fbc1be6004.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 38 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ed-4a28-727d-ac73-2325a048a142.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14ed-4a28-727d-ac73-2325a048a142",
        "storage_key": "property/5657559276978176/019f14ed-4a28-727d-ac73-2325a048a142.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_55b1489772b62719671e6557",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Baylor Scott & White Medical Center - Grapevine",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1650 W College St, Grapevine, TX 76051, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-ea23-769e-a016-f9ff1fb3827e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-ea23-769e-a016-f9ff1fb3827e",
        "storage_key": "property/5657559276978176/019f14ec-ea23-769e-a016-f9ff1fb3827e.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/grapevine?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-7927435",
      "poi_directions_map_url": "https://maps.google.com/?cid=10745585466151126275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-medical-center---grapevine",
      "poi_latitude": "32.9341727",
      "poi_longitude": "-97.0935352",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 817-481-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4c52-773e-85fc-a360e4589de3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4c52-773e-85fc-a360e4589de3",
        "storage_key": "property/5657559276978176/019f14e9-4c52-773e-85fc-a360e4589de3.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1a5P6tLUTYYRA8WJhQz9H5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_64558553af90e70466107917",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "poi_name": "Responsive Education Solutions",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1301 Waters Ridge Dr, Lewisville, TX 75057, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14ec-ec0f-743d-8f66-711bbe452666.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ec-ec0f-743d-8f66-711bbe452666",
        "storage_key": "property/5657559276978176/019f14ec-ec0f-743d-8f66-711bbe452666.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://responsiveed.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6544263307394845829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "responsive-education-solutions",
      "poi_latitude": "33.0257186",
      "poi_longitude": "-96.9752578",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-316-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14e9-4d12-75a9-91d7-3ae1e39c2a6a",
        "storage_key": "property/5657559276978176/019f14e9-4d12-75a9-91d7-3ae1e39c2a6a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj3LuDFouTIYRhYzkGc7k0Vo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_3212fdec-4e2d-436a-9503-251fd2df8339",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_185aafb7-f2b2-4716-b771-8a059ff1db1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_79841171-6b9c-405e-94db-eb1dd3ed8545",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_174ed4a3-1654-410f-a65b-5c0867b5bf10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_bb774478-800d-4340-8c90-3ebcf8fb2e8c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a9f1aa0f-2514-4919-b70b-cbeb3d4cebfa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_43beb6be-01e0-4dd4-85c7-e51cff5b2987",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [
    {
      "id": "ec_cbd4191689390f81a330eceb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14c2-e348-70b8-9e6a-b12a2f9a524b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-e348-70b8-9e6a-b12a2f9a524b",
        "storage_key": "property/5657559276978176/019f14c2-e348-70b8-9e6a-b12a2f9a524b.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The View at Lakeside",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/SkRnsFODaiA"
    },
    {
      "id": "ec_e042ab2e2f65f26f0a2647f7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019d02ef-eab5-75df-93e6-961dd9a0a0df.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior view of an apartment with dining area, living space, and hallway.",
        "public_id": "019d02ef-eab5-75df-93e6-961dd9a0a0df",
        "storage_key": "property/5657559276978176/019d02ef-eab5-75df-93e6-961dd9a0a0df.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1137SF - B2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=jp7ovT3Ap5v&play=1"
    },
    {
      "id": "ec_d47a3a9ca9eb8bcbbc3a93a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14c2-e14d-730c-8290-dd1fffe2cb11.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-e14d-730c-8290-dd1fffe2cb11",
        "storage_key": "property/5657559276978176/019f14c2-e14d-730c-8290-dd1fffe2cb11.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=gudumnwqqzN&play=1"
    },
    {
      "id": "ec_d89aba720ec07967f1789907",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14c2-f5a2-773c-af81-83ec3bae6dde.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-f5a2-773c-af81-83ec3bae6dde",
        "storage_key": "property/5657559276978176/019f14c2-f5a2-773c-af81-83ec3bae6dde.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QinpYdSg25W&play=1"
    },
    {
      "id": "ec_0bc9f3ebc42327f74b0f5e6d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f14c2-f584-7209-8716-38c0dd739e8f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-f584-7209-8716-38c0dd739e8f",
        "storage_key": "property/5657559276978176/019f14c2-f584-7209-8716-38c0dd739e8f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Playground / Volleyball",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1WinH48C9DK&play=1"
    },
    {
      "id": "ec_6610f34d19dc670f60e0f9dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019d02ef-ed7c-7019-bea0-9812c8edab6f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Apartment complex swimming pool and hot tub area with lounge chairs and umbrellas.",
        "public_id": "019d02ef-ed7c-7019-bea0-9812c8edab6f",
        "storage_key": "property/5657559276978176/019d02ef-ed7c-7019-bea0-9812c8edab6f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Swimming Pool 1",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=a171uwY5oUP&play=1"
    },
    {
      "id": "ec_b4047d10fa48ed721d21737b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019d02ef-f454-71bf-9293-679e6f7c0765.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Swimming pool with lounge chairs and a fence overlooking a body of water.",
        "public_id": "019d02ef-f454-71bf-9293-679e6f7c0765",
        "storage_key": "property/5657559276978176/019d02ef-f454-71bf-9293-679e6f7c0765.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Swimming Pool 2",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ogb8nCN7ZKm&play=1"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-6970-75ef-adc5-37c7c9452a73",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-view-at-lakeside",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176"
    },
    {
      "lead_collector_id": "0198aa46-69d1-73fe-b935-92b08b38f463",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-view-at-lakeside",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176"
    },
    {
      "lead_collector_id": "0198aa46-6a34-707d-84f3-baec6816f7fc",
      "lead_source": "LANDING_PAGE",
      "name": "the-view-at-lakeside",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-lewisville-tx",
      "search_query": "One Bedroom Apartments For Rent In Lewisville TX",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent in Lewisville, TX",
      "h2_subtitle": "The View at Lakeside offers luxurious one-bedroom apartments in a serene lakeside setting. Enjoy modern amenities and convenient access to local attractions.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exquisite one bedroom apartments for rent in Lewisville, TX. Our community is ideally located near Music City Mall and Hebron Station, providing easy access to the A Train and major highways. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our one-bedroom apartments are designed with your comfort in mind, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "One Bedroom Apartments For Rent in Lewisville, TX",
      "seo_description": "Explore The View at Lakeside for one bedroom apartments for rent in Lewisville, TX. Enjoy modern amenities and a serene lakeside setting near local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "explore-two-bedrooms-apartments-for-rent-lewisville-tx",
      "search_query": "Two Bedrooms Apartments For Rent In Lewisville TX",
      "category": "Floorplan",
      "h1_title": "Explore Two Bedroom Apartments For Rent in Lewisville, TX",
      "h2_subtitle": "The View at Lakeside offers spacious two-bedroom apartments with modern amenities. Enjoy a vibrant community and convenient access to local attractions.",
      "page_copy": "Discover the perfect two bedroom apartments for rent in Lewisville, TX at The View at Lakeside. Our community is ideally situated near Music City Mall and Hebron Station, offering easy access to the A Train and major highways. Each two-bedroom apartment features expansive floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can indulge in a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our two-bedroom apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the ideal blend of luxury and convenience at The View at Lakeside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Two Bedroom Apartments For Rent in Lewisville, TX",
      "seo_description": "Find two bedroom apartments for rent in Lewisville, TX at The View at Lakeside. Enjoy modern amenities and a vibrant community near local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "find-three-bedrooms-apartments-for-rent-lewisville-tx",
      "search_query": "Three Bedrooms Apartments For Rent In Lewisville TX",
      "category": "Floorplan",
      "h1_title": "Find Three Bedroom Apartments For Rent in Lewisville, TX",
      "h2_subtitle": "The View at Lakeside offers expansive three-bedroom apartments with luxurious amenities. Enjoy a serene lakeside setting and easy access to local attractions.",
      "page_copy": "Welcome to The View at Lakeside, where you can find spacious three bedroom apartments for rent in Lewisville, TX. Our community is conveniently located near Music City Mall and Hebron Station, providing easy access to the A Train and major highways. Each three-bedroom apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our three-bedroom apartments are designed with your comfort in mind, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Three Bedroom Apartments For Rent in Lewisville, TX",
      "seo_description": "Discover three bedroom apartments in Lewisville, TX at The View at Lakeside. Enjoy luxurious amenities and a serene lakeside setting near local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near You with a Pool",
      "h2_subtitle": "The View at Lakeside offers luxurious apartments with a resort-style pool. Enjoy a vibrant community with modern amenities and convenient access to local attractions.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent near you with pool access. Our community is ideally located near Music City Mall and Hebron Station, providing easy access to the A Train and major highways. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can indulge in a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where relaxation and recreation are just steps away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The View at Lakeside | Apartments For Rent Near Me with Pool",
      "seo_description": "Find apartments for rent near you with pool access at The View at Lakeside. Enjoy luxurious amenities and a vibrant community near local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near You with a Fitness Center",
      "h2_subtitle": "The View at Lakeside offers modern apartments with a state-of-the-art fitness center. Enjoy a vibrant community with convenient access to local attractions.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent near you with fitness center access. Our community is ideally located near Music City Mall and Hebron Station, providing easy access to the A Train and major highways. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a state-of-the-art fitness center, a resort-style swimming pool, and a sand volleyball court. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where fitness and relaxation are just steps away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Discover apartments for rent near you with fitness center access at The View at Lakeside. Enjoy top amenities and a vibrant community near local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-spa",
      "search_query": "Apartments For Rent Near Me with Spa",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near You with a Spa",
      "h2_subtitle": "The View at Lakeside offers luxurious apartments with spa amenities. Enjoy a serene community with modern conveniences and easy access to local attractions.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent near you with spa access. Our community is ideally located near Music City Mall and Hebron Station, providing easy access to the A Train and major highways. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can indulge in a variety of amenities, including a relaxing spa, a resort-style swimming pool, and a state-of-the-art fitness center. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where relaxation and rejuvenation are just steps away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The View at Lakeside | Apartments For Rent Near Me with Spa",
      "seo_description": "Find apartments for rent near you with spa access at The View at Lakeside. Enjoy luxurious amenities and a serene community near local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-clubhouse",
      "search_query": "Apartments For Rent Near Me with Clubhouse",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near You with a Clubhouse",
      "h2_subtitle": "The View at Lakeside offers modern apartments with a vibrant clubhouse. Enjoy a welcoming community with convenient access to local attractions and amenities.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent near you with clubhouse access. Our community is ideally located near Music City Mall and Hebron Station, providing easy access to the A Train and major highways. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a welcoming clubhouse, a resort-style swimming pool, and a state-of-the-art fitness center. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where community and comfort are just steps away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments For Rent Near Me with Clubhouse",
      "seo_description": "Discover apartments for rent near you with clubhouse access at The View at Lakeside. Enjoy modern amenities and a welcoming community near local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-lounge",
      "search_query": "Apartments For Rent Near Me with Lounge",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near You with a Lounge",
      "h2_subtitle": "The View at Lakeside offers stylish apartments with a relaxing lounge. Enjoy a vibrant community with modern amenities and convenient access to local attractions.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent near you with lounge access. Our community is ideally located near Music City Mall and Hebron Station, providing easy access to the A Train and major highways. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a relaxing lounge, a resort-style swimming pool, and a state-of-the-art fitness center. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where relaxation and community are just steps away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The View at Lakeside | Apartments Near Me with Lounge",
      "seo_description": "Find apartments for rent near you with lounge access at The View at Lakeside. Enjoy modern amenities and a vibrant community near local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-pantry",
      "search_query": "Apartments For Rent Near Me with Pantry",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near You with a Pantry",
      "h2_subtitle": "The View at Lakeside offers modern apartments with spacious pantries. Enjoy a vibrant community with convenient access to local attractions and amenities.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent near you with pantry space that enhances your kitchen experience. Our community is ideally located near Music City Mall and Hebron Station, providing easy access to the A Train and major highways. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our apartments are designed for your comfort, featuring granite countertops, stainless steel appliances, and ample pantry space. Experience the perfect blend of luxury and convenience at The View at Lakeside, where modern living meets practical design.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The View at Lakeside | Apartments Near Me with Pantry",
      "seo_description": "Find apartments for rent near you with pantry space at The View at Lakeside. Enjoy modern features and a vibrant community near local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-granite",
      "search_query": "Apartments For Rent Near Me with Granite Countertops",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near You with Granite Countertops",
      "h2_subtitle": "The View at Lakeside offers luxurious apartments with elegant granite countertops. Enjoy a vibrant community with modern amenities and convenient access to local attractions.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent near you with granite countertops that add a touch of elegance to your kitchen. Our community is ideally located near Music City Mall and Hebron Station, providing easy access to the A Train and major highways. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our apartments are designed for your comfort, featuring stainless steel appliances, ample pantry space, and of course, stunning granite countertops. Experience the perfect blend of luxury and convenience at The View at Lakeside, where modern living meets sophisticated design.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments For Rent Near Me with Granite Countertops",
      "seo_description": "Find apartments for rent near you with granite countertops at The View at Lakeside. Enjoy modern features and a vibrant community near local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-stainless-steel",
      "search_query": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near You with Stainless Steel Appliances",
      "h2_subtitle": "The View at Lakeside offers modern apartments with sleek stainless steel appliances. Enjoy a vibrant community with convenient access to local attractions and amenities.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent near you with stainless steel appliances that enhance your kitchen's functionality and style. Our community is ideally located near Music City Mall and Hebron Station, providing easy access to the A Train and major highways. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our apartments are designed for your comfort, featuring granite countertops, ample pantry space, and of course, modern stainless steel appliances. Experience the perfect blend of luxury and convenience at The View at Lakeside, where contemporary living meets sophisticated design.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "seo_description": "Discover apartments near you with stainless steel appliances at The View at Lakeside. Enjoy modern features and a vibrant community near local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-lewisville-tx-near-medical-city",
      "search_query": "Apartments For Rent In Lewisville TX Near Medical City Lewisville",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent in Lewisville, TX Near Medical City Lewisville",
      "h2_subtitle": "The View at Lakeside offers convenient living near Medical City Lewisville. Enjoy modern amenities and a serene lakeside setting in a prime location.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent in Lewisville, TX near Medical City Lewisville. Our community is ideally located with easy access to major highways, making it convenient for healthcare professionals and residents seeking proximity to comprehensive medical services. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where modern living meets a prime location near essential healthcare facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments in Lewisville, TX Near Medical City Lewisville",
      "seo_description": "Find apartments for rent in Lewisville, TX near Medical City Lewisville at The View at Lakeside. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-lewisville-tx-near-medical-center",
      "search_query": "Apartments For Rent In Lewisville TX Near Carrollton Regional Medical Center",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Lewisville, TX Near Carrollton Regional Medical Center",
      "h2_subtitle": "The View at Lakeside offers convenient living near Carrollton Regional Medical Center. Enjoy modern amenities and a serene lakeside setting in a prime location.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent in Lewisville, TX near Carrollton Regional Medical Center. Our community is ideally located with easy access to major highways, making it convenient for healthcare professionals and residents seeking proximity to high-quality medical care. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where modern living meets a prime location near essential healthcare facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments Near Carrollton Regional Medical Center",
      "seo_description": "Discover apartments for rent in Lewisville, TX near Carrollton Regional Medical Center at The View at Lakeside. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-lewisville-tx-near-plano-hospital",
      "search_query": "Apartments For Rent In Lewisville TX Near Plano Surgical Hospital",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Lewisville, TX Near Plano Surgical Hospital",
      "h2_subtitle": "The View at Lakeside offers convenient living near Plano Surgical Hospital. Enjoy modern amenities and a serene lakeside setting in a prime location.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent in Lewisville, TX near Plano Surgical Hospital. Our community is ideally located with easy access to major highways, making it convenient for healthcare professionals and residents seeking proximity to specialized medical services. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where modern living meets a prime location near essential healthcare facilities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments in Lewisville, TX Near Plano Surgical Hospital",
      "seo_description": "Discover apartments for rent in Lewisville, TX near Plano Surgical Hospital at The View at Lakeside. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-lewisville-tx-near-utd",
      "search_query": "Apartments For Rent In Lewisville TX Near The University of Texas at Dallas",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent in Lewisville, TX Near The University of Texas at Dallas",
      "h2_subtitle": "The View at Lakeside offers convenient living near The University of Texas at Dallas. Enjoy modern amenities and a serene lakeside setting in a prime location.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent in Lewisville, TX near The University of Texas at Dallas. Our community is ideally located with easy access to major highways, making it convenient for students and faculty seeking proximity to the university. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where modern living meets a prime location near educational excellence.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments Near The University of Texas at Dallas",
      "seo_description": "Find apartments for rent in Lewisville, TX near The University of Texas at Dallas at The View at Lakeside. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-lewisville-tx-near-dallas-college",
      "search_query": "Apartments For Rent In Lewisville TX Near Dallas College Brookhaven Campus",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Lewisville, TX Near Dallas College Brookhaven Campus",
      "h2_subtitle": "The View at Lakeside offers convenient living near Dallas College Brookhaven Campus. Enjoy modern amenities and a serene lakeside setting in a prime location.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent in Lewisville, TX near Dallas College Brookhaven Campus. Our community is ideally located with easy access to major highways, making it convenient for students and faculty seeking proximity to the college. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where modern living meets a prime location near educational opportunities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments Near Dallas College Brookhaven Campus",
      "seo_description": "Discover apartments for rent in Lewisville, TX near Dallas College Brookhaven Campus at The View at Lakeside. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-lewisville-tx-near-dallas-college",
      "search_query": "Apartments For Rent In Lewisville TX Near Dallas College North Lake Campus",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent in Lewisville, TX Near Dallas College North Lake Campus",
      "h2_subtitle": "The View at Lakeside offers convenient living near Dallas College North Lake Campus. Enjoy modern amenities and a serene lakeside setting in a prime location.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent in Lewisville, TX near Dallas College North Lake Campus. Our community is ideally located with easy access to major highways, making it convenient for students and faculty seeking proximity to the college. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where modern living meets a prime location near educational opportunities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments Near Dallas College North Lake Campus",
      "seo_description": "Find apartments for rent in Lewisville, TX near Dallas College North Lake Campus at The View at Lakeside. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-lewisville-tx-near-uti",
      "search_query": "Apartments For Rent In Lewisville TX Near Universal Technical Institute",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Lewisville, TX Near Universal Technical Institute",
      "h2_subtitle": "The View at Lakeside offers convenient living near Universal Technical Institute. Enjoy modern amenities and a serene lakeside setting in a prime location.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent in Lewisville, TX near Universal Technical Institute. Our community is ideally located with easy access to major highways, making it convenient for students and faculty seeking proximity to the institute. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nResidents can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where modern living meets a prime location near educational opportunities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments in Lewisville Near Universal Technical Institute",
      "seo_description": "Discover apartments for rent in Lewisville, TX near Universal Technical Institute at The View at Lakeside. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-lewisville-tx-near-rockbrook",
      "search_query": "Apartments For Rent In Lewisville TX Near Rockbrook Elementary School",
      "category": "POI",
      "h1_title": "Find Apartments For Rent in Lewisville, TX Near Rockbrook Elementary School",
      "h2_subtitle": "The View at Lakeside offers family-friendly living just 3.9 km from Rockbrook Elementary School. Enjoy spacious floor plans and modern amenities in a prime location.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent in Lewisville, TX near Rockbrook Elementary School. Our community is perfectly situated just 3.9 km away, making it an ideal choice for families seeking proximity to quality education within the Westside Community Schools district. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nFamilies can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where family living meets a prime location near educational opportunities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments in Lewisville Near Rockbrook Elementary School",
      "seo_description": "Discover family-friendly apartments for rent in Lewisville, TX near Rockbrook Elementary School at The View at Lakeside.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5657559276978176",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-lewisville-tx-near-high-school",
      "search_query": "Apartments For Rent In Lewisville TX Near Lewisville High School",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent in Lewisville, TX Near Lewisville High School",
      "h2_subtitle": "The View at Lakeside offers family-friendly living just 9.6 km from Lewisville High School. Enjoy spacious floor plans and modern amenities in a prime location.",
      "page_copy": "Welcome to The View at Lakeside, where you can find exceptional apartments for rent in Lewisville, TX near Lewisville High School. Our community is conveniently located just 9.6 km away, making it an ideal choice for families seeking proximity to quality education. Each apartment features deluxe floor plans with gourmet kitchens, in-home fireplaces, and charming wrap-around patios. \n\nFamilies can enjoy a variety of amenities, including a resort-style swimming pool, a state-of-the-art fitness center, and a sand volleyball court. Our apartments are designed for your comfort, featuring Wi-Fi, washer/dryer hookups, and ceiling fans. Experience the perfect blend of luxury and convenience at The View at Lakeside, where family living meets a prime location near educational opportunities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019f6c13-ea1c-768c-b9b6-22df8ed748a4",
        "storage_key": "property/5657559276978176/019f6c13-ea1c-768c-b9b6-22df8ed748a4.webp",
        "width": 1058,
        "height": 703
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
      "blank_image_media": {
        "alt_text": "Black background",
        "public_id": "019f6c13-f17e-7369-a769-fd8a7efb1a6d",
        "storage_key": "property/5657559276978176/019f6c13-f17e-7369-a769-fd8a7efb1a6d.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Apartments in Lewisville, TX Near Lewisville High School",
      "seo_description": "Find family-friendly apartments for rent in Lewisville, TX near Lewisville High School at The View at Lakeside. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2219"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376470922"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a69\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a69\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4432366"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WLBD4B3"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "3"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443209787"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "f11f152df61debe9"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/yzvgdqezvln"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/ecd77b9c-6548-457f-8718-a11af7d5b632"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "469-658-8691"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im5FRXV5WksvQjlhNUczbDRNcWlLbkE9PSIsInZhbHVlIjoiVUYwYVpQMGNmMlRZMFVqYndKTktpZz09IiwibWFjIjoiYzc1YzMxNjgzOTVkYTVjNGJkOTY5ZmRhMjk2Mjk3Njc2NWY3ZTRlMTJiZjMyMzZhZjNiMjIxYjRiNDFmZTk0YyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2219",
  "custom_repli_id": "2376470922",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a69\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a69\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4432366",
  "custom_google_gtm_id": "GTM-WLBD4B3",
  "custom_rollout_phase": "3",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443209787",
  "custom_knock_community_id": "f11f152df61debe9",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/yzvgdqezvln",
  "custom_self_guided_tour_url": "https://selftournow.com/property/ecd77b9c-6548-457f-8718-a11af7d5b632",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "469-658-8691",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im5FRXV5WksvQjlhNUczbDRNcWlLbkE9PSIsInZhbHVlIjoiVUYwYVpQMGNmMlRZMFVqYndKTktpZz09IiwibWFjIjoiYzc1YzMxNjgzOTVkYTVjNGJkOTY5ZmRhMjk2Mjk3Njc2NWY3ZTRlMTJiZjMyMzZhZjNiMjIxYjRiNDFmZTk0YyJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "c9b506f6-4391-42bb-bf4c-e8588d18d6ed",
  "custom_audioeye_site_hash": "81819295bf6f87abb52775947bbc62ab"
};

export const generatedAt = '2026-11-03T20:27:33.356Z';
